<template>
	<div>
		<div
			style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
			v-if="LoaderStatus"
		>
			<Spinner />
		</div>
		<div class="proct-parentdiv" style="background: #ffffff">
			<div class="d-flex align-items-center">
				<div
					class="pointer"
					@click="goBackPointer(overallResult, selectedAttempt)"
				>
					<img src="../../assets/icons/Reports/bckarrow.svg" alt="" />
				</div>
				<div class="headtext d-flex align-items-center">
					<div class="heading ml-3">
						<span> {{ overallResult.candidatename }} </span>
					</div>
				</div>
			</div>
			<div>
				<div
					class="mt-2 pr-candidate-header-div p-2 d-flex justify-content-between align-items-center"
				>
					<div
						class="d-flex"
						:style="
							overallResult.candidateType == 'I' ? 'width:40%' : 'width:25%'
						"
					>
						<div class="pvc-detail-text text-truncate">
							Topic Name :
							<span class="pvd-dp-text">{{
								getFormattedTopicName(overallResult.topicName)
							}}</span>
						</div>
					</div>
					<div
						class="d-flex ml-3"
						:style="
							overallResult.candidateType == 'I' ? 'width:40%' : 'width:25%'
						"
					>
						<div class="pvc-detail-text text-truncate">
							Test Name :

							<span class="pvd-dp-text">
								{{ overallResult.testName }}
							</span>
						</div>
					</div>
					<div
						class="d-flex ml-3"
						style="width: 30%"
						v-if="overallResult.candidateType != 'I'"
					>
						<div class="pvc-detail-text text-truncate">
							Group Name :
							<span class="pvd-dp-text">
								{{ overallResult.groupName }}
							</span>
						</div>
					</div>
					<div class="priority-div p-2">
						<span v-if="overallResult.priorityAttemptID != null">
							<img
								src="../../assets/icons/proctoring/priorityicon.svg"
								alt=""
								style="margin-bottom: 4px"
							/>
							Priority attempt is attempt {{ overallResult.priorityAttemptID }}
						</span>
						<span>{{ overallResult.priorityAttemptStatus }}</span>
					</div>
				</div>
				<div class="tabbed mt-3 mb-0">
					<b-tabs style="width: 100%" v-model="tabIndex">
						<b-tab
							v-for="(candidate, index) in overallResult.attempts"
							:key="index"
							:title="`Attempt ${index + 1}`"
							@click="getProctorDetailsData(candidate)"
						>
							<template #title>
								<div class="relativeclass">
									<div
										class="vpt-priorityicon"
										v-if="candidate == overallResult.priorityAttemptID"
									>
										<img
											src="../../assets/icons/proctoring/priorityicon.svg"
											alt=""
										/>
									</div>
									<div>Attempt {{ index + 1 }}</div>
								</div>
							</template>
						</b-tab>
					</b-tabs>
					<template>
						<div class="mt-2 d-flex gap-5 pl-2 pr-2">
							<div class="vcp-top-left-container">
								<div class="pvc-card">
									<div class="pvc-content">
										<div class="d-flex align-items-center">
											<div class="pvd-profileimg">
												<img
													src="../../assets/icons/proctoring/dp.png"
													alt=""
													class="img-height-width"
												/>
											</div>
											<div class="d-flex pvd-dp-text flex-column ml-3">
												<div>
													{{ selectedAttempt.name }}
												</div>
												<div class="vcp-email">
													{{ selectedAttempt.emailID }}
												</div>
											</div>
										</div>
										<div style="width: 100%">
											<div class="d-flex align-items-center mt-2">
												<span style="width: 10%"
													><img
														src="../../assets/icons/proctoring/tv.svg"
														alt=""
												/></span>
												<span class="pvc-detail-text ml-3" style="width: 90%">
													<template v-if="selectedAttempt.stats != undefined">
														--
													</template>
													<template
														v-else-if="
															Object.keys(selectedAttempt.stats).length != 0 &&
																Object.keys(selectedAttempt.stats.system)
																	.length != 0
														"
													>
														{{ selectedAttempt.stats.system }}
													</template>
													<template v-else> -- </template>
												</span>
											</div>

											<div class="d-flex align-items-center mt-2">
												<span style="width: 10%"
													><img
														src="../../assets/icons/proctoring/location.svg"
														alt=""
												/></span>
												<span
													v-if="
														selectedAttempt.stats.geolocation != undefined &&
															selectedAttempt.stats.geolocation.address &&
															selectedAttempt.stats.geolocation.address
																.formatted_address
													"
													class="pvc-detail-text ml-3 mt-1"
													style="width: 90%"
												>
													{{
														selectedAttempt.stats.geolocation.address
															.formatted_address
													}}
												</span>
												<span v-else>-</span>
											</div>
										</div>
										<div style="width: 100%">
											<hr />

											<div class="d-flex justify-content-between mt-2">
												<div>
													<div class="pvc-detail-text">Date & Time</div>
													<div
														style="width: 70%"
														class="pvd-dp-text"
														v-if="
															selectedAttempt.stats == null ||
																Object.keys(selectedAttempt.stats).length === 0
														"
													>
														--
													</div>

													<div class="pvd-dp-text" v-else>
														{{
															formatDate(
																selectedAttempt.stats.timing.startTime.slice(
																	0,
																	10
																),
																"dd/MM/yyyy"
															)
														}}
														&
														{{
															selectedAttempt.stats.timing.startTime.slice(
																11,
																19
															)
														}}
													</div>
												</div>

												<div>
													<div
														class="d-flex flex-column ml-4"
														style="width: 75%"
													>
														<span class="pd-card-middle-head">Time Taken </span>
														<span class="bluenumbertext">
															<template
																v-if="
																	Object.keys(selectedAttempt.stats).length != 0
																"
															>
																<template
																	v-if="
																		selectedAttempt.stats.timing.duration != ''
																	"
																>
																	<span class="yellownumbertext"
																		>{{
																			(
																				"0" +
																				selectedAttempt.stats.timing.duration.slice(
																					0,
																					7
																				)
																			).slice(-8)
																		}}(HH:MM:SS)
																	</span>
																</template>
																<template v-else>--</template>
															</template>
															<template v-else>--</template>
														</span>
													</div>
												</div>
											</div>

											<div
												class="d-flex align-items-center mt-2 pr-viewmark p-3"
												:class="
													selectedAttempt.evaluation
														? ' justify-content-between'
														: ' justify-content-center'
												"
											>
												<template v-if="selectedAttempt.evaluation">
													<div class="d-flex">
														<span class="pd-card-middle-head mr-2"
															>Marks Obtained :
														</span>
														<span class="proctoring-sub-heading">
															<template
																v-if="selectedAttempt.marks != undefined"
																>{{ selectedAttempt.marks }}/{{
																	selectedAttempt.totalTestMarks
																		.toString()
																		.substring(0, 4)
																}}</template
															>
															<template v-else> -- </template>
														</span>
													</div>
													<div>
														<span
															:class="
																selectedAttempt.statusCode == 0
																	? 'pr-fail'
																	: 'pr-pass'
															"
															>{{ selectedAttempt.status }}</span
														>
													</div>
													<div
														class="pd-card-middle-head pointer"
														style="text-decoration-line: underline"
														@click="viewCandidateModal(selectedAttempt)"
													>
														Attempt Details
														<img
															src="../../assets/icons/proctoring/result.svg"
															alt=""
															class="ml-2"
														/>
													</div>
												</template>
												<template v-else>
													<div
														class="evaluated-status ml-1"
														v-if="!selectedAttempt.isSubmitted"
													>
														Not Submitted
													</div>
													<div v-else class="evaluated-status ml-1">
														Not Yet Evaluated
													</div>
												</template>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div class="vcp-top-id-container p-2">
								<div class="proctoring-sub-heading">Person Face Capture</div>
								<template v-if="selectedAttempt['candidateImage']">
									<div style="height: 250px; width: 465px">
										<img
											:src="selectedAttempt.candidateImage"
											class="img-height-width"
											alt=""
										/>
									</div>
								</template>
								<template v-else>
									<div style="height: 250px; width: 465px">
										<img
											src="../../assets/icons/proctoring/noImage.svg"
											alt=""
											class="img-height-width"
										/>
									</div>
								</template>
							</div>
							<div class="vcp-top-id-container p-2">
								<div class="proctoring-sub-heading">ID Card Capture</div>
								<template v-if="selectedAttempt['candidateImageWithID']">
									<div style="height: 250px; width: 465px">
										<img
											:src="selectedAttempt.candidateImageWithID"
											class="img-height-width"
											alt=""
										/>
									</div>
								</template>
								<template v-else>
									<div style="height: 250px; width: 465px">
										<img
											src="../../assets/icons/proctoring/noID.svg"
											alt=""
											class="img-height-width"
										/>
									</div>
								</template>
							</div>
						</div>
						<div class="d-flex mt-3 gap-5 pl-2 pr-2">
							<div class="vcp-bottom-left-container p-2">
								<div class="d-flex align-items-center text-center w-100 mb-2">
									<div
										class="ongng-txt pointer w-50 p-2"
										@click="status = 'video'"
										:class="
											status == 'video'
												? 'proctoringTabSelected'
												: 'proctoringTabUnSelected'
										"
									>
										Video Feed
									</div>
									<div
										class="ongng-txt pointer w-50 p-2"
										@click="status = 'screen'"
										:class="
											status == 'screen'
												? 'proctoringTabSelected'
												: 'proctoringTabUnSelected'
										"
									>
										Screen Share Feed
									</div>
								</div>
								<div>
									<template v-if="selectedAttempt['video'] != undefined">
										<div
											id="video-tag"
											class="d-flex justify-content-center"
											v-if="
												status == 'video' &&
													Object.keys(selectedAttempt.video).length != 0 &&
													selectedAttempt.video['camera']
											"
										>
											<video
												aria-describedby="video-tag"
												style="width: 320px; height: 200px"
												id="screenshare"
												:src="selectedAttempt.video.camera"
												controls
												autoplay
											/>
										</div>
										<div
											id="video-tag1"
											class="d-flex justify-content-center"
											v-else-if="
												status == 'screen' &&
													Object.keys(selectedAttempt.video).length != 0 &&
													selectedAttempt.video['screenShare']
											"
										>
											<video
												aria-describedby="video-tag1"
												style="width: 320px; height: 200px"
												id="video"
												:src="selectedAttempt.video.screenShare"
												controls
												autoplay
											/>
										</div>
									</template>
									<div v-else>
										<img
											src="../../assets/icons/proctoring/noVideo.svg"
											class="img-height-width"
											alt=""
										/>
									</div>
									<div class="overall-smmary mt-2">Overall Summary</div>
									<div
										class="qb-gotopage-text pr-overall-log d-flex align-items-center justify-content-center"
										v-if="selectedAttempt.activityLog == undefined"
									>
										<img
											src="../../assets/icons/proctoring/overallSummary.svg"
											alt=""
										/>
									</div>
									<template v-else>
										<div class="mt-3 pr-overall-log">
											<div
												class="proct-cards mb-2 p-2"
												v-for="(data,
												logindex) in selectedAttempt.activityLogCount"
												:key="logindex"
											>
												<div>
													<div
														class="d-flex justfy-content-between align-items-center relativeclass tp-gridcont flexgrid"
													>
														<div
															:style="cssForDynamicColor"
															style="background: var(--dynamicBorderColor)"
															class="gridgreencolorDynamic"
														></div>

														<div style="width: 65%">
															<div class="d-flex tp-text pd-card-test-head">
																{{ data.activity }}
															</div>
														</div>

														<div class="d-flex flex-column" style="width: 20%">
															<span class="pd-card-middle-head">Count</span>

															<span class="yellownumbertext">{{
																data.count
															}}</span>
														</div>
													</div>
												</div>
											</div>
										</div>
									</template>
								</div>
							</div>

							<div class="vcp-bottom-right-container-div">
								<div class="vcp-bottom-right-container p-2">
									<div class="proctoring-sub-heading">
										Complete Activity Details
									</div>
									<div class="table-main mt-2">
										<table
											class="w-100 pvc-table pr-fourthscreen-logtable selected-dash-table"
											aria-describedby="table-description"
										>
											<thead>
												<tr>
													<th style="width: 15%" class="text-left p-3">
														<span>Time</span>
													</th>
													<th style="width: 50%" class="text-left p-3">
														<span>Activity</span>
													</th>

													<th style="width: 30%" class="text-left p-3">
														<span>Category</span>
													</th>
												</tr>
											</thead>

											<tbody>
												<div
													class="d-flex align-items-center justify-content-center flex-column h-100"
													v-if="selectedAttempt.activityLog == undefined"
												>
													<div>
														<img src="../../assets/activitydetail.svg" alt="" />
													</div>
													<div class="activity-status mt-2">
														There is no activity recorded
													</div>
												</div>
												<div v-else>
													<tr
														v-for="(i, index) in selectedAttempt.activityLog"
														:key="index"
													>
														<td
															style="width: 15%"
															class="p-3 text-left pointer"
															@click="vidplay(i.timeStampInVideo)"
														>
															{{ i.timeStampInVideo }}
														</td>
														<td style="width: 50%" class="p-3 text-left">
															{{ i.activityDescription }}
															<span v-if="i.count > 1">({{ i.count }})</span>
														</td>
														<td style="width: 30%" class="p-3 text-left">
															{{ i.type }}
														</td>
													</tr>
												</div>
											</tbody>
										</table>
									</div>
								</div>
								<div class="pr-feedback-container p-2 mt-2">
									<div class="proctoring-sub-heading">Feedback</div>
									<template v-if="selectedAttempt.remarks.length != 0">
										<div
											v-if="selectedAttempt.remarks[3].answer.length > 0"
											class="pr-feedback-remarks p-2 mt-2 mb-2"
										>
											{{ selectedAttempt.remarks[3].answer }}
										</div>
										<b-row
											:style="
												selectedAttempt.remarks[3].answer.length > 0
													? 'margin-top:0.5rem;'
													: 'margin-top:4rem;'
											"
										>
											<b-col class="text-center proctoring-sub-heading ml-3"
												>Question Pattern</b-col
											>
											<b-col class="text-center proctoring-sub-heading ml-3"
												>Time allocated for the test</b-col
											>
											<b-col class="text-center proctoring-sub-heading ml-3"
												>Overall Experience</b-col
											>
										</b-row>
										<b-row>
											<b-col class="d-flex justify-content-center">
												<b-form-rating
													id="rating-lg"
													size="lg"
													class="rating-input w-50"
													v-model="selectedAttempt.remarks[0].answer"
													disabled
												></b-form-rating
											></b-col>
											<b-col class="d-flex justify-content-center">
												<b-form-rating
													id="rating-lg"
													size="lg"
													class="rating-input w-50"
													v-model="selectedAttempt.remarks[1].answer"
													disabled
												></b-form-rating
											></b-col>
											<b-col class="d-flex justify-content-center">
												<b-form-rating
													id="rating-lg"
													size="lg"
													class="rating-input w-50"
													v-model="selectedAttempt.remarks[2].answer"
													disabled
												></b-form-rating
											></b-col>
										</b-row>
									</template>
									<template v-else>
										<div
											class="d-flex justify-content-center align-items-center h-100"
										>
											<img
												src="../../assets/icons/proctoring/noFeedback.svg"
												alt=""
											/>
										</div>
									</template>
								</div>
							</div>
						</div>
						<div class="mt-3 pr-main-card-container mb-2">
							<b-row class="pl-2 pr-2">
								<b-col cols="6">
									<div class="pr-left-column-container p-3">
										<div class="add-access-user-head">
											Communication Test Result
										</div>
										<template v-if="selectedAttempt.communicationTest != null">
											<div
												class="d-flex justify-content-between align-items-center mt-2"
											>
												<template
													v-if="Object.keys(keyWordRepeatingCount).length != 0"
												>
													<div class="pr-left-column-left-div p-2">
														<div class="pr-keyword-use">Keywords Count</div>

														<div class="pr-left-column-left-div-inner">
															<div
																v-for="(i, ctindex) in keyWordRepeatingCount"
																:key="ctindex"
																class="d-flex pr-keywords-used-cards pr-keywords-used-cards-txt align-items-center justify-content-between pl-1 pr-1"
																:class="ctindex == 0 ? 'ml-1 mr-1 mb-1' : 'm-1'"
															>
																<div>{{ ctindex }}</div>

																<div>
																	<strong>{{ i }} </strong>Times
																</div>
															</div>
														</div>
													</div>
												</template>

												<template v-else>
													<div class="pr-left-column-left-div p-2">
														<div class="pr-keyword-use">Keywords Used</div>
														<div class="pr-left-column-left-div-inner">
															<div
																v-for="(i, ctindex) in selectedAttempt
																	.communicationTest.communicationTestResponse
																	.keyWords"
																:key="ctindex"
																class="d-flex pr-keywords-used-cards pr-keywords-used-cards-txt align-items-center justify-content-between pl-1 pr-1"
																:class="ctindex == 0 ? 'ml-1 mr-1 mb-1' : 'm-1'"
															>
																<div>{{ i }}</div>
															</div>
														</div>
													</div>
												</template>
												<div class="pr-left-column-right-div ml-3">
													<img
														:src="
															selectedAttempt.communicationTest
																.communicationTestResponse.mediaResource[0]
																.mediaLink
														"
														alt=""
														class="h-100 w-100"
													/>
												</div>
											</div>

											<div class="mt-3 pr-keyword-use">Candidate answer is</div>

											<div
												class="pr-candidate-answer pr-keywords-used-cards-txt mt-2 p-2"
											>
												<div>
													{{
														selectedAttempt.communicationTest
															.communicationTestResponse.analysisResult
															.textConverted
													}}
												</div>
											</div>
											<div
												class="d-flex align-items-center justify-content-between pr-communication-test-result-bottom-div mt-2 p-1"
											>
												<div
													class="d-flex align-items-center"
													style="width: 30%"
												>
													<div class="pr-options">Hear the Answer</div>
													<div class="mt-2 pointer">
														<audio id="audioPlayer" ref="audioRef"></audio>
														<span @click="toggleAudio()">
															<img
																v-if="isPlaying"
																src="../../assets/icons/proctoring/pause.svg"
																alt=""
															/>
															<img
																v-else
																src="../../assets/icons/proctoring/play.svg"
																alt=""
															/>
														</span>
													</div>
													<div
														class="w-25 timeline"
														@click="seekTimeline($event)"
													>
														<div
															class="timeline-progress"
															:style="{ width: timelineWidth }"
														></div>
													</div>
												</div>
												<div class="pr-options">
													Total Attempts Given :
													<strong>{{
														selectedAttempt.communicationTest
															.communicationTestResponse
															.communicationTestAttemptNo
													}}</strong>
												</div>

												<div
													class="pr-options"
													v-if="
														selectedAttempt.communicationTest
															.communicationTestResponse
															.communicationTestAttemptNo != 1
													"
												>
													Total retakes :
													<strong>{{
														selectedAttempt.communicationTest
															.communicationTestResponse
															.communicationTestAttemptNo - 1
													}}</strong>
												</div>
												<div class="d-flex align-items-center">
													<div class="pr-options mr-1">Test Result :</div>
													<div
														v-if="
															selectedAttempt.communicationTest
																.communicationTestResponse.analysisResult
																.textConverted != ''
														"
														style="
                              font-weight: 500;
                              font-size: 13px;
                              color: #038e00;
                            "
													>
														Passed
													</div>
													<div
														v-else
														style="
                              font-weight: 500;
                              font-size: 13px;
                              color: red;
                            "
													>
														Failed
													</div>
												</div>
											</div>
										</template>
										<template v-else>
											<div
												class="d-flex justify-content-center align-items-center h-100"
											>
												<img
													src="../../assets/icons/proctoring/noCommunicationTest.svg"
													alt=""
												/>
											</div>
										</template>
									</div>
								</b-col>

								<b-col cols="6">
									<div class="pr-right-column-container p-3">
										<div class="add-access-user-head">Typing Test Result</div>
										<template v-if="selectedAttempt.typingTest != null">
											<div
												class="d-flex align-items-center justify-content-between mt-2"
											>
												<div
													class="d-flex align-items-center justify-content-between pr-typing-test-cards typing-test-subheading p-2"
												>
													<div class="typing-test-subheading">Typing Speed</div>
													<div class="pr-typing-test-cards-blue-text">
														{{ selectedAttempt.typingTest.analysisResult.wpm }}
														WPM
													</div>
												</div>
												<div
													class="d-flex align-items-center justify-content-between pr-typing-test-cards typing-test-subheading p-2"
												>
													<div class="typing-test-subheading">Accuracy</div>
													<div class="pr-typing-test-cards-blue-text">
														{{
															selectedAttempt.typingTest.analysisResult.accuracy
														}}
														%
													</div>
												</div>
												<div
													class="d-flex align-items-center justify-content-between pr-typing-test-cards typing-test-subheading p-2"
												>
													<div class="typing-test-subheading">Mistakes</div>
													<div class="pr-typing-test-cards-blue-text">
														{{
															selectedAttempt.typingTest.analysisResult.mistakes
														}}
													</div>
												</div>
											</div>
											<div class="pr-question mt-3 p-2">
												<div class="pr-keyword-use">Passage</div>
												<div class="pr-keywords-used-cards-txt mt-1">
													{{ selectedAttempt.typingTest.paragraph }}
												</div>
											</div>
											<div class="pr-keyword-use mt-3">Candidate Response</div>
											<div
												class="pr-keywords-used-cards-txt p-2 pr-answer mt-2"
											>
												<div>
													<template
														v-if="
															selectedAttempt.typingTest.analysisResult[
																'answer'
															]
														"
													>
														{{
															selectedAttempt.typingTest.analysisResult.answer
														}}
													</template>
													<template v-else> -- </template>
												</div>
											</div>
										</template>
										<template v-else>
											<div
												class="d-flex justify-content-center align-items-center h-100"
											>
												<img
													src="../../assets/icons/proctoring/noTypingTest.svg"
													alt=""
												/>
											</div>
										</template>
									</div>
								</b-col>
							</b-row>
						</div>
					</template>
				</div>
				<div
					v-if="
						selectedAttempt.testResponse.length != 0 &&
							roles.includes('EVALUATE_TEST') &&
							(!selectedAttempt.sandboxResults ||
								Object.keys(selectedAttempt.sandboxResults).length === 0)
					"
				>
					<div
						class="d-flex justify-content-between align-items-center mt-2 pl-2 pr-2"
					>
						<div v-if="selectedAttempt.markingCheck" class="ans-sheet-txt">
							Evaluate Assessment
						</div>
						<div v-else class="ans-sheet-txt">Test Details</div>
						<div class="d-flex align-items-center">
							<div class="d-flex align-items-center eval-negativemark-heading">
								<div class="eval-status-button-heading">
									Negative Marks Allocated for this test :
								</div>
								<div class="ml-1 evaluated-status">
									{{ selectedAttempt.negativeMark }}
								</div>
							</div>
							<div class="eval-status d-flex align-items-center ml-2">
								<div class="eval-status-button-heading">Result :</div>
								<div
									class="evaluated-status-evaluated ml-1"
									v-if="selectedAttempt.evaluation"
								>
									Evaluated
								</div>
								<div
									class="evaluated-status ml-1"
									v-else-if="!selectedAttempt.isSubmitted"
								>
									Not Submitted
								</div>
								<div class="evaluated-status ml-1" v-else>
									Not Yet Evaluated
								</div>
							</div>
						</div>
					</div>

					<!-- New design of evaluate Assessment Tabs -->
					<template>
						<div>
							<b-tabs class="main-tabs">
								<!-- First level tabs -->
								<b-tab
									@click="(activeTab = 'sections'), (codingsection = false)"
								>
									<template #title>
										<div
											class="d-flex align-items-center justify-content-center"
										>
											<img
												class="mr-2"
												v-if="activeTab === 'sections'"
												src="../../assets/icons/proctoring/sections-active-tab.svg"
												alt=""
											/>
											<img
												class="mr-2"
												v-else
												src="../../assets/icons/proctoring/sections-inactive-tab.svg"
												alt=""
											/>
											Sections
										</div>
									</template>
									<!-- Second level tabs -->
									<b-tabs class="sub-tabs">
										<b-tab
											v-for="(section, k) in allQuestions"
											:key="k"
											@click="selectSection(section)"
										>
											<!-- Content for Sub Tab 1 -->
											<template #title>
												<div
													:id="`${k}-popover-target-2`"
													class="text-break pointer ellipsis"
												>
													{{ section.sectionName }}
													<img
														class="eval-validationicon-top mb-1 ml-3"
														src="../../assets/deletepopupicon.svg"
														alt=""
														v-b-popover.hover.left.v-danger="{
															content: 'Please evaluate all questions',
														}"
														v-if="section.sectionError"
													/>
												</div>

												<b-popover
													:target="`${k}-popover-target-2`"
													triggers="hover"
													placement="top"
												>
													{{ section.sectionName }}
												</b-popover>
											</template>
										</b-tab>
									</b-tabs>
								</b-tab>
								<!-- second level tabs-->
								<b-tab
									v-if="codingquestions.length > 0"
									@click="(activeTab = 'coding'), (codingsection = true)"
								>
									<template #title>
										<div
											class="d-flex align-items-center justify-content-center"
										>
											<img
												class="mr-2"
												v-if="activeTab === 'coding'"
												src="../../assets/icons/proctoring/coding-test-active-tab.svg"
												alt=""
											/>
											<img
												class="mr-2"
												v-else
												src="../../assets/icons/proctoring/coding-test-In-active-tab.svg"
												alt=""
											/>
											Coding Test
										</div>
									</template>
									<!-- Content for Tab 2 -->
									<b-tabs v-if="codingquestions.length > 0" class="sub-tabs">
										<b-tab
											v-for="(item, i) in codingquestions"
											:key="i"
											@click="selectCodeSection(i)"
										>
											<!-- Content for Sub Tab 1 -->
											<template #title>
												<div
													:id="`${i}-popover-target-1`"
													class="text-break pointer ellipsis"
												>
													Programming {{ i + 1 }}
													<img
														class="eval-validationicon-top mb-1 ml-3"
														src="../../assets/deletepopupicon.svg"
														alt=""
														v-b-popover.hover.left.v-danger="{
															content: 'Please evaluate all questions',
														}"
														v-if="item.sectionError"
													/>
												</div>

												<b-popover
													:target="`${i}-popover-target-1`"
													triggers="hover"
													placement="top"
												>
													Programming {{ i + 1 }}
												</b-popover>
											</template>
										</b-tab>
									</b-tabs>
								</b-tab>
							</b-tabs>
						</div>
					</template>

					<div class="mt-3 proctor-evaluate-div relativeclass p-3">
						<template v-if="!codingsection">
							<div class="pr-tabcontent-evaltest" id="top1">
								<div
									class="answercards relativeclass"
									:class="index == 0 ? '' : 'mt-3'"
									v-for="(i, index) in selectedSection.sectionResponse"
									:key="i.questionKey + selectedSection.sectionID"
								>
									<div
										:class="
											i.hasOwnProperty('questionMarks')
												? i.questionMarks != undefined
													? 'gridbluecolor'
													: i.questionKey.slice(0, 3) == 'MCQ'
													? i.answer == i.questionBody.correctanswer
														? 'gridgreencolor'
														: i.answerStatus.attempted
														? 'gridgreencolor'
														: 'gridredcolor'
													: i.answerStatus.attempted
													? 'gridgreencolor'
													: 'gridredcolor'
												: i.questionKey.slice(0, 3) == 'MAF'
												? mtfcrctans
													? 'gridgreencolor'
													: i.answerStatus.attempted
													? 'gridgreencolor'
													: 'gridredcolor'
												: 'orangecolor'
										"
									></div>
									<div
										class="sec-quescard-headtext"
										v-if="i.questionKey.startsWith('MCQ')"
									>
										MCQ
									</div>

									<div
										class="sec-quescard-headtext"
										v-else-if="i.questionKey.startsWith('MAF')"
									>
										Match The Following
									</div>

									<div
										class="sec-quescard-headtext"
										v-else-if="i.questionKey.startsWith('LON')"
									>
										Descriptive
									</div>
									<div class="answertext ml-2">
										<b-row>
											<b-col cols="9">
												<div class="d-flex">
													<div>Q{{ parseInt(index) + 1 }}.</div>
													<div
														class="ml-1 text-break"
														v-html="i.questionBody.question"
													></div>
												</div>
											</b-col>
											<b-col cols="3">
												<div
													style="width: 75%"
													class="d-flex align-items-center justify-content-end mr-2"
												>
													<template v-if="selectedAttempt.markingCheck">
														<div
															class="topDiv d-flex relativeclass givemark vcps"
														>
															<label class="fieldsetStyle" style="z-index: 8"
																>Give Marks &nbsp;<span class="asterik"
																	>*</span
																></label
															>

															<b-form-input
																class="vcp-inputField"
																id="input-1"
																type="text"
																:placeholder="
																	selectedAttempt.markingCheck
																		? 'Enter here'
																		: ''
																"
																@input="updateBetweenValue(parseInt(index))"
																v-model="i.questionMarks"
																:class="
																	$v.selectedSection.sectionResponse.$each[
																		index
																	].questionMarks.$error ||
																	i.questionBody.betweenError
																		? 'error'
																		: ''
																"
															></b-form-input>
															<div
																class="eval-validationicon"
																v-if="
																	$v.selectedSection.sectionResponse.$each[
																		index
																	].questionMarks.$error ||
																		i.questionBody.betweenError
																"
																v-b-popover.hover.top.v-danger="{
																	content: 'Required',
																}"
																variant="primary"
															>
																<img
																	src="../../assets/deletepopupicon.svg"
																	alt=""
																/>
															</div>
															<div
																class="eval-validationicon"
																v-if="
																	!$v.selectedSection.sectionResponse.$each[
																		index
																	].questionMarks.required &&
																		$v.selectedSection.sectionResponse.$each[
																			index
																		].questionMarks.$dirty
																"
																v-b-popover.hover.top.v-danger="{
																	content: 'Required',
																}"
																variant="primary"
															>
																<img
																	src="../../assets/deletepopupicon.svg"
																	alt=""
																/>
															</div>
															<div
																class="eval-validationicon"
																v-if="
																	i.questionBody.betweenError &&
																		$v.selectedSection.sectionResponse.$each[
																			index
																		].questionMarks.required &&
																		!i.answerStatus.unattempted
																"
																v-b-popover.hover.top.v-danger="{
																	content: `Entered Marks Should Be Within The Range Of ${
																		selectedAttempt.negativeMark > 0
																			? selectedAttempt.negativeMark * -1
																			: 0
																	}  To  ${i.questionBody.marks}`,
																}"
																variant="primary"
															>
																<img
																	src="../../assets/deletepopupicon.svg"
																	alt=""
																/>
															</div>
															<div
																class="eval-validationicon"
																v-if="
																	i.questionBody.betweenError &&
																		$v.selectedSection.sectionResponse.$each[
																			index
																		].questionMarks.required &&
																		i.answerStatus.unattempted
																"
																v-b-popover.hover.top.v-danger="{
																	content: `Entered Marks Should Be Within The Range Of ${
																		selectedAttempt.negativeMark > 0
																			? selectedAttempt.negativeMark * -1
																			: 0
																	}  To  0`,
																}"
																variant="primary"
															>
																<img
																	src="../../assets/deletepopupicon.svg"
																	alt=""
																/>
															</div>
															<div
																class="eval-validationicon"
																v-else-if="
																	!$v.selectedSection.sectionResponse.$each[
																		index
																	].questionMarks.alpha &&
																		$v.selectedSection.sectionResponse.$each[
																			index
																		].questionMarks.required &&
																		$v.selectedSection.sectionResponse.$each[
																			index
																		].questionMark != 0
																"
																v-b-popover.hover.top.v-danger="{
																	content:
																		'No Special characters allowed except .',
																}"
																variant="primary"
															>
																<img
																	src="../../assets/deletepopupicon.svg"
																	alt=""
																/>
															</div>
														</div>
													</template>
													<div v-else-if="selectedAttempt.evaluation == true">
														{{ i.questionMarks }}
													</div>
													<div v-else>--</div>
													<div class="totalmarktext ml-2">
														/&nbsp;{{ i.questionBody.marks }}
													</div>
												</div>
											</b-col>
										</b-row>
										<template
											v-if="
												'questionMedia' in i.questionBody &&
													i.questionBody.questionMedia != null
											"
										>
											<div
												v-if="isImage(i.questionBody.questionMediaType)"
												class="mt-2 mb-2 d-flex align-items-center justify-content-center pr-image-div"
											>
												<div class="relativeclass">
													<img
														:src="i.questionBody.questionMedia"
														alt=""
														class="dbmcqcardimage"
													/>
												</div>
											</div>

											<!-- below div comes if audio exists -->
											<div
												v-if="isAudio(i.questionBody.questionMediaType)"
												class="d-flex mt-2 mb-2 align-items-center justify-content-start"
											>
												<div>
													<Media
														:kind="'audio'"
														:isMuted="false"
														:autoplay="false"
														:controls="true"
														:loop="true"
														class="mcqdatacard-audio"
														:src="i.questionBody.questionMedia"
													></Media>
												</div>
											</div>
											<div
												v-if="isVideo(i.questionBody.questionMediaType)"
												class="d-flex mt-2 mb-2 align-items-center justify-content-center pr-image-div"
											>
												<div class="relativeclass">
													<Media
														:kind="'video'"
														:isMuted="false"
														:src="i.questionBody.questionMedia"
														:autoplay="false"
														:controls="true"
														:loop="true"
														class="dbmcqcardimage"
													></Media>
												</div>
											</div>
										</template>
										<b-row v-if="i.questionKey.slice(0, 3) == 'MCQ'">
											<b-col cols="10">
												<div class="ml-5 mt-3">
													<b-row>
														<b-col
															v-for="(options, index) in i.questionBody.options"
															:key="index"
															cols="6"
															:class="{
																'mcq-checkbox':
																	i.questionBody.noOfCorrectOptionsAllowed > 1,
																dbmradios:
																	!i.questionBody.noOfCorrectOptionsAllowed ||
																	i.noOfCorrectOptionsAllowed <= 1,
															}"
														>
															<b-form-checkbox
																v-if="
																	i.questionBody.noOfCorrectOptionsAllowed >
																		1 && Array.isArray(i.answer)
																"
																v-model="i.answer"
																:value="options.value"
																disabled
																name="some-radios"
																>{{ options.value }}</b-form-checkbox
															>
															<b-form-radio
																v-else
																:class="
																	i.answer == options.value
																		? 'sec-ques-green'
																		: 'sec-questions-radios'
																"
																disabled
																value="first"
																>{{ options.value }}
															</b-form-radio>
															<!-- give filter "topicNameFilter" -->
														</b-col>
													</b-row>
												</div>
												<div v-if="showmcqans == i.questionKey">
													<hr />
													<div class="ans-text">Answer :</div>
													<div
														class="mt-2"
														v-for="(options, index) in i.questionBody.options"
														:key="index"
													>
														<div v-if="options.check == true">
															<div class="crct-ans-box pl-2 mt-2">
																{{ options.value }}
															</div>
														</div>
													</div>
												</div>
											</b-col>
											<b-col cols="2">
												<div class="pointer">
													<div
														v-if="showmcqans == i.questionKey"
														class="view-ans-text d-flex justify-content-end"
														@click="showmcqans = ''"
													>
														Hide answer
													</div>
													<div
														v-else
														class="view-ans-text d-flex justify-content-end"
														@click="showmcqanswer(i.questionKey)"
													>
														View answer
													</div>
												</div></b-col
											>
										</b-row>
										<b-row v-else-if="i.questionKey.slice(0, 3) == 'MAF'">
											<b-col cols="10">
												<div>
													<b-row class="mofo-answrdiv mb-1 pb-2">
														<b-col>
															<div
																v-for="(option, index) in i.questionBody
																	.answerKey"
																:key="index"
															>
																<div class="mafo-option-text p-2 mt-3 w-100">
																	{{ option.sideA }}
																</div>
															</div>
														</b-col>
														<b-col>
															<div
																v-for="(maf, index) in i.answer"
																:key="index"
																class="ml-4 d-flex align-items-center"
															>
																<div
																	class="d-flex align-items-center disablesixdots mafo-option-text1 p-2 mt-3"
																>
																	<img
																		src="../../assets/disablesixdots.svg"
																		alt=""
																	/>
																</div>
																<div class="mafo-option-text p-2 mt-3 w-100">
																	{{ maf }}
																</div>
															</div></b-col
														>
													</b-row>
													<div v-if="showmcqans == i.questionKey">
														<hr />
														<div class="mt-2">
															<div class="ans-text">Answer :</div>
															<div
																class="mofo-answrdiv d-flex justify-content-between mt-2"
																v-for="(option, index) in i.questionBody
																	.answerKey"
																:key="index"
															>
																<div
																	class="mafo-option-text d-flex pl-2 align-items-center"
																>
																	{{ option.sideA }}
																</div>
																<div
																	class="mafo-option-text ml-4 d-flex align-items-center"
																>
																	<div
																		class="d-flex align-items-center disablesixdots"
																	>
																		<img
																			src="../../assets/disablesixdots.svg"
																			alt=""
																		/>
																	</div>
																	<div class="ml-2 d-flex align-items-center">
																		{{ option.sideB }}
																	</div>
																</div>
															</div>
														</div>
													</div>
												</div>
											</b-col>
											<b-col cols="2">
												<div class="pointer">
													<div
														v-if="showmcqans == i.questionKey"
														class="view-ans-text d-flex justify-content-end"
														@click="showmcqans = ''"
													>
														Hide answer
													</div>
													<div
														v-else
														class="view-ans-text d-flex justify-content-end"
														@click="showmcqanswer(i.questionKey)"
													>
														View answer
													</div>
												</div></b-col
											>
										</b-row>
										<b-row v-else>
											<b-col cols="9">
												<div class="mt-2">
													<b-form-textarea
														id="textarea"
														v-model="i.answer"
														style="overflow-y: auto"
														rows="3"
														max-rows="6"
														disabled
													>
													</b-form-textarea>
												</div>
											</b-col>
										</b-row>
									</div>
								</div>
							</div>
						</template>

						<template v-else>
							<div class="codingTestprgrm mt-3">
								<span class="codingTestprgrm-text-1"
									>Programming {{ programnumber }} :
								</span>
								<span class="codingTestprgrm-text-2">{{
									selectedCodeSection.sectionName
								}}</span>
							</div>

							<div class="pr-tabcontent-evaltest-programming-table" id="top1">
								<div
									class="answercards relativeclass mt-3 ml-1 mb-2"
									v-for="(question, i) in selectedCodeSection.sectionResponse"
									:key="i"
								>
									<div class="gridbluecolor"></div>

									<div class="d-flex">
										<div style="width: 80%">
											<div class="ml-3">
												<span class="codingTestprgrm-container-text-head"
													>Q{{ i + 1 }}.
												</span>
												<span
													class="ml-2 codingTestprgrm-container-text-head"
													>{{ question.questionBody.title }}</span
												>
											</div>

											<div
												class="codingTestprgrm-container-body mt-2 ml-5"
												v-html-safe="question.questionBody.question"
											></div>
										</div>

										<div style="width: 20%" class="flex-column">
											<div class="d-flex w-100 justify-content-center">
												<template v-if="selectedAttempt.markingCheck">
													<div class="topDiv d-flex mt-3">
														<label class="fieldsetStyle" style="z-index: 8"
															>Give Marks &nbsp;<span class="asterik"
																>*</span
															></label
														>

														<b-form-input
															class="vcp-inputField"
															id="input-1"
															type="text"
															:placeholder="
																selectedAttempt.markingCheck ? 'Enter here' : ''
															"
															@input="updateCodeBetweenValue(parseInt(i))"
															v-model="question.questionMarks"
															:class="
																$v.selectedCodeSection.sectionResponse.$each[i]
																	.questionMarks.$error ||
																question.questionBody.betweenError
																	? 'error'
																	: ''
															"
														></b-form-input>
														<div
															class="eval-validationicon"
															v-if="
																$v.selectedCodeSection.sectionResponse.$each[i]
																	.questionMarks.$error ||
																	question.questionBody.betweenError
															"
															v-b-popover.hover.top.v-danger="{
																content: 'Required',
															}"
															variant="primary"
														>
															<img
																src="../../assets/deletepopupicon.svg"
																alt=""
															/>
														</div>
														<div
															class="eval-validationicon"
															v-if="
																!$v.selectedCodeSection.sectionResponse.$each[i]
																	.questionMarks.required &&
																	$v.selectedCodeSection.sectionResponse.$each[
																		i
																	].questionMarks.$dirty
															"
															v-b-popover.hover.top.v-danger="{
																content: 'Required',
															}"
															variant="primary"
														>
															<img
																src="../../assets/deletepopupicon.svg"
																alt=""
															/>
														</div>
														<div
															class="eval-validationicon"
															v-if="
																question.questionBody.betweenError &&
																	$v.selectedCodeSection.sectionResponse.$each[
																		i
																	].questionMarks.required &&
																	!question.answerStatus.unattempted
															"
															v-b-popover.hover.top.v-danger="{
																content: `Entered Marks Should Be Within The Range Of -${selectedAttempt.negativeMark}  To  ${question.questionBody.marks}`,
															}"
															variant="primary"
														>
															<img
																src="../../assets/deletepopupicon.svg"
																alt=""
															/>
														</div>
														<div
															class="eval-validationicon"
															v-if="
																question.questionBody.betweenError &&
																	$v.selectedCodeSection.sectionResponse.$each[
																		i
																	].questionMarks.required &&
																	question.answerStatus.unattempted
															"
															v-b-popover.hover.top.v-danger="{
																content: `Entered Marks Should Be Within The Range Of ${
																	selectedAttempt.negativeMark > 0
																		? selectedAttempt.negativeMark * -1
																		: 0
																}  To  0`,
															}"
															variant="primary"
														>
															<img
																src="../../assets/deletepopupicon.svg"
																alt=""
															/>
														</div>
														<div
															class="eval-validationicon"
															v-if="
																!$v.selectedCodeSection.sectionResponse.$each[i]
																	.questionMarks.alpha &&
																	$v.selectedCodeSection.sectionResponse.$each[
																		i
																	].questionMarks.required &&
																	$v.selectedSection.sectionResponse.$each[
																		index
																	].questionMark != 0
															"
															v-b-popover.hover.top.v-danger="{
																content:
																	'No Special characters allowed except .',
															}"
															variant="primary"
														>
															<img
																src="../../assets/deletepopupicon.svg"
																alt=""
															/>
														</div>
													</div>
												</template>
												<div v-else-if="selectedAttempt.evaluation">
													{{ question.questionMarks }}
												</div>
												<div class="progrm-totalmarktext mt-4 ml-2">
													/&nbsp;{{ question.questionBody.marks }}
												</div>
											</div>

											<div
												class="d-flex align-items-center justify-content-center mt-3 w-100"
												@click="
													$bvModal.show('ViewAnswerDatabank'),
														viewanswer(question, parseInt(i))
												"
											>
												<div class="viewAnswer-class pointer">View Answer</div>
												<div class="ml-3">
													<img
														src="../../assets/icons/proctoring/protoring-codeTest-rightArrow.svg"
														alt=""
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</template>

						<div class="d-flex justify-content-between eval-button-box">
							<div class="d-flex align-items-center relativeclass">
								<div class="eval-button-head">
									<img src="../../assets/non-evaluated.svg" alt="" />
									Non Evaluated
								</div>
								<div class="ml-2 eval-button-head">
									<img src="../../assets/evaluated.svg" alt="" />
									Evaluated
								</div>
								<div class="ml-2 eval-button-head">
									<img src="../../assets/non-Attempted.svg" alt="" />
									Non Attempted
								</div>
								<div class="ml-2 eval-button-head">
									<img src="../../assets/attempted.svg" alt="" />
									Attempted
								</div>
							</div>
							<div class="text-right" v-if="selectedAttempt.markingCheck">
								<b-button class="addbtn pl-2 pr-2 mr-2" @click="evaluate()"
									>Evaluate</b-button
								>
							</div>
						</div>
					</div>
				</div>
				<div
					v-else-if="
						(roles.includes('EVALUATE_TEST') ||
							selectedAttempt.testResponse.length == 0) &&
							(!selectedAttempt.sandboxResults ||
								Object.keys(selectedAttempt.sandboxResults).length === 0)
					"
					class="pr-candidate-header-div qb-gotopage-text p-3 d-flex justify-content-center mb-3"
				>
					Not Started Taking Test
				</div>
				<section
					v-if="
						selectedAttempt.sandboxResults &&
							Object.keys(selectedAttempt.sandboxResults).length > 0
					"
					class="mt-4"
				>
					<main class="performance-cont flex-1 p-3">
						<section class="d-flex justify-content-between align-items-center">
							<div class="ans-sheet-txt ml-2">Sandbox Evaluation</div>
							<div class="d-flex justify-content-between">
								<div
									v-if="selectedAttempt.evaluation"
									class="eval-btns mr-2 d-flex justify-content-between align-content-center align-items-center"
								>
									<div>Marks:</div>
									<b-form-input
										disabled
										placeholder="Enter Marks"
										v-model="selectedAttempt.marks"
										class="evaluate-sandbox-input width-80px ml-2"
									/>
									<div class="out-off-marks">
										/ {{ selectedAttempt.totalTestMarks }}
									</div>
								</div>
								<div v-else class="eval-btns mr-2">
									<b-button v-if="!giveMarks" @click="giveMarks = true">
										<img
											class="mr-2"
											src="../../assets/projects-icons/evaluate-screen/givemarks-sb.svg"
											alt=""
										/>
										Give Marks
									</b-button>
									<div
										v-else
										class="d-flex justify-content-between align-content-center"
									>
										<b-form-input
											placeholder="Enter Marks"
											v-model="sandboxMarks"
											class="evaluate-sandbox-input"
											:class="
												validationsTrigger && !isValid ? 'red-border' : ''
											"
										/>
										<div class="out-off-marks-eval">
											/ {{ selectedAttempt.totalTestMarks }}
										</div>
										<img
											@click="giveMarks = false"
											class="mr-2 pointer"
											src="../../assets/projects-icons/undoMarks.svg"
											alt=""
										/>
										<img
											@click="evaluateSandboxMethod()"
											class="mr-2 pointer"
											src="../../assets/projects-icons/saveMarks.svg"
											alt=""
										/>
									</div>
								</div>
								<div class="eval-btns mr-2">
									<b-button @click="vewSandboxCode()">
										<img
											class="mr-2"
											src="../../assets/projects-icons/evaluate-screen/view-sb.svg"
											alt=""
										/>
										View Code Sandbox
									</b-button>
								</div>
							</div>
						</section>
						<section
							v-if="selectedAttempt.sandboxResults === 'pending'"
							class="performance-cont flex-1 mt-3 d-flex flex-column align-items-center justify-content-center p-5"
						>
							<img src="../../assets/no-sand.svg" alt="" />
							<span class="mt-4 pm-no-data-txt"
								>The metrics are being generated. Please refresh the page or
								come back later to check.</span
							>
						</section>
						<section
							v-else-if="selectedAttempt.sandboxResults"
							class="d-flex pm-gap-3 mt-3"
						>
							<article
								class="performance-cont pm-w-65 p-2"
								v-if="selectedAttempt.sandboxResults.SONARQUBE"
							>
								<div
									class="d-flex justify-content-between align-items-center px-3"
								>
									<span class="headtxt-sb">SonarQube</span>
									<div
										class="d-flex justify-content-between align-items-center"
									>
										<span
											@click="$bvModal.show('proctoringModal')"
											class="headtxt-blue mr-1 pointer"
											>View all Parameters</span
										>
									</div>
								</div>
								<hr class="" my-2 />
								<div class="d-flex pm-gap-3 px-3 pb-3 pt-2">
									<article
										v-for="metric in selectedAttempt.sandboxResults.SONARQUBE.slice(
											0,
											4
										)"
										:key="metric.metric"
										class="pm-card pm-width-unset"
									>
										<h4>{{ metric.label }}</h4>
										<h2>{{ metric.value }}</h2>
										<h6>
											{{ metric.description }}
										</h6>
									</article>
								</div>
							</article>
							<article
								v-if="
									selectedAttempt.sandboxResults.DB_TRIGGER ||
										buildAndRunDetails
								"
								:class="{
									'flex-column': selectedAttempt.sandboxResults.SONARQUBE,
								}"
								class="pm-w-35 d-flex pm-gap-3"
							>
								<div
									class="performance-cont flex-1 p-2"
									v-if="buildAndRunDetails"
								>
									<div class="headtxt-sb">
										{{ buildAndRunDetails.label }}
									</div>
									<hr class="my-2" />
									<div class="d-flex align-items-center py-3 px-2">
										<img
											v-if="buildAndRunDetails.value"
											src="../../assets/projects-icons/evaluate-screen/true.svg"
										/>
										<img
											v-else
											src="../../assets/projects-icons/evaluate-screen/false.svg"
										/>
										<span class="parameter-txt-hd ml-3">{{
											buildAndRunDetails.value
										}}</span>
									</div>
								</div>

								<div
									class="performance-cont flex-1 p-2"
									v-if="selectedAttempt.sandboxResults.DB_TRIGGER"
								>
									<div class="headtxt-sb">DB Triggers</div>
									<hr class="my-2" />
									<div class="d-flex align-items-center py-3 px-2">
										<img
											src="../../assets/projects-icons/evaluate-screen/true.svg"
										/>
										<span class="parameter-txt-hd ml-3">{{
											selectedAttempt.sandboxResults.DB_TRIGGER
										}}</span>
									</div>
								</div>
							</article>
						</section>
					</main>
				</section>
			</div>
		</div>
		<!-- view answer model starts here -->
		<b-modal
			size="xl"
			id="ViewAnswerDatabank"
			ref="ViewAnswerDatabank"
			centered
			hide-footer
			hide-header
			no-close-on-backdrop
			class="p-0"
			@hidden="modalHidden"
			@shown="modalShown"
		>
			<div
				class="modalheading d-flex align-items-center justify-content-between"
			>
				<span class="ViewAnswer-head-text">View Answer</span>
			</div>

			<div
				class="xMarkCancel"
				@click="$bvModal.hide('ViewAnswerDatabank'), (showResult = false)"
			>
				<img src="../../assets/cross-round.svg" alt="" />
			</div>
			<hr />

			<div class="d-flex pt-1 viewAnswerMaincontent">
				<div class="viewAnswerLeftSideContent">
					<div class="d-flex align-items-center">
						<div class="viewAnswer-small-box">
							Difficulty Level -
							{{ question.questionBody.difficultyLevel }}
						</div>
						<div class="viewAnswer-small-box">
							Marks - {{ question.questionBody.marks }}
						</div>
						<div class="viewAnswer-small-box">
							Category : {{ question.questionBody.category }} <b></b>
						</div>
					</div>

					<div class="viewAnswer-tags-text mt-2 mt-3 ml-4 d-flex">
						Tags :
						<div
							class="ml-1"
							v-for="(tag, k) in question.questionBody.questionTags"
							:key="k"
						>
							{{ tag
							}}<span v-if="k < question.questionBody.questionTags.length - 1"
								>,</span
							>
						</div>
					</div>
					<div class="mt-2">
						<span class="viewAnswer-totalQuesnum">Q1.&nbsp;</span
						><span
							class="ml-1"
							style="color: #333; font-size: 13px; font-weight: 600"
							>{{ question.questionBody.title }}</span
						>
					</div>

					<div>
						<div class="viewAnswer-tags-text mt-2">
							<u>Question:</u>
						</div>
						<div
							class="viewAnswer-tags-text mt-2"
							v-html-safe="question.questionBody.question"
						></div>
					</div>

					<div class="viewAnswer-left-card mt-2">
						<span>Constraints:</span>
						<div
							class="mt-2 qpc-tags-text"
							v-html-safe="question.questionBody.constraints"
						></div>
					</div>

					<div class="viewAnswer-left-card list-style-class mt-2">
						<span>Sample</span>
						<div class="mt-2">
							<ul>
								<li>
									Input:
									<span v-html-safe="question.questionBody.sampleInput"></span>
								</li>
								<li>
									Output:
									<span v-html-safe="question.questionBody.sampleOutput"></span>
								</li>
							</ul>
						</div>
					</div>

					<div class="viewAnswer-left-card mt-2">
						<span>Test Cases</span>
						<div class="d-flex align-items-center mt-2">
							<img
								src="../../assets/icons/proctoring/proctoring-testcase-infoIcon.svg"
								alt=""
							/>
							<div class="viewAnswer-tags-text ml-2">
								These are all visible test cases
							</div>
						</div>
						<div class="d-flex mt-2">
							<div class="proctoring-tc" style="width: 25%">
								<div
									class="p-2 proctoring-tc-text"
									v-for="(tc, i) in visibletc"
									:key="i"
									@click="displayIcon(i)"
									:class="{
										'proctoring-tc-sel-text': dispIcon === i,
									}"
								>
									Test Case {{ i + 1 }}
								</div>
							</div>
							<div style="width: 75%">
								<div class="viewAnswer-left-card p-3 ml-2">
									<div class="candAnswer-tc-preview-head">Input</div>
									<div class="viewAnswer-tags-text ml-3 mt-2">
										{{ tc.inputValue }}
									</div>
								</div>
								<div class="viewAnswer-left-card p-3 ml-2 mt-2">
									<div class="candAnswer-tc-preview-head">Output</div>
									<div class="viewAnswer-tags-text ml-3 mt-2">
										{{ tc.outputValue }}
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="ml-3 viewAnswerRightSideContent">
					<div class="d-flex justify-content-end">
						<img
							class="mr-3"
							v-b-popover.hover.top="'Full Screen'"
							src="../../assets/fullscreen.svg"
							alt=""
							srcset=""
							@click="showInFullScreen()"
						/>
						<div style="width: 40%" class="position-relative mr-2">
							<div
								class="cq-lang-container d-flex align-items-center justify-content-between"
							>
								<div class="cq-accept-lang">Selected Language</div>
								<div class="cq-langline"></div>
								<div class="cq-lang-text">
									{{ topicCardselected }}
								</div>
							</div>
						</div>
					</div>
					<div
						class="editorContainer candAnswer-code-body w-100 mt-2"
						id="editorContainer"
					></div>

					<div class="d-flex justify-content-end mt-3 mr-1">
						<b-button
							class="addbtn pl-4 pr-4"
							@click="runCodeForCompilation(question.questionKey)"
							>Run Code</b-button
						>
					</div>
					<div v-if="showResult" ref="scrollContainer">
						<div class="candAnswer-test-result mt-2 ml-2">Test Result</div>

						<div class="candAnswer-bottom-button m-1 mr-1">
							<div>
								<div
									class="candAnswer-redTop"
									v-if="compiledTestCasesResult.totalTestCasesFailed > 0"
								>
									Compilation Failed -
									{{ compiledTestCasesResult.totalTestCasesFailed }}/{{
										compiledTestCasesResult.totalTestCases
									}}
									test cases Failed
								</div>
								<div
									class="candAnswer-greenTop"
									v-if="compiledTestCasesResult.totalTestCasesFailed <= 0"
								>
									Completed Successfully - All test cases are passed
								</div>
								<div class="p-2">
									<span> Compile Message </span>
									<div
										class="viewAnswer-tags-text mt-2"
										v-html-safe="compilemsg"
									></div>
								</div>
							</div>
							<hr />
							<div class="candAnswer-tc-card p-2">
								<span>Test Cases</span>
								<div class="d-flex mt-2">
									<div
										class="candAnswer-tc-many-trialCase-left"
										style="width: 20%"
									>
										<div
											:style="i % 2 == 0 ? 'background: #EEF2F5;' : ''"
											class="p-2 proctoring-tc-text pointer"
											v-for="(data,
											i) in compiledTestCasesResult.testCaseResult"
											:key="i"
											@click="hideIcon(i, data)"
											:class="
												showIcon === i ? 'candAnswer-showClickedTestCase' : ''
											"
										>
											<img
												v-if="data.resultCode == 0"
												class="mr-1"
												src="../../assets/testCaseFail.svg"
												alt=""
											/>
											<img
												v-else
												class="mr-1"
												src="../../assets/testCasePass.svg"
												alt=""
											/>
											Test Case {{ i + 1 }}
											<img
												v-if="!data.visible"
												class="ml-2"
												src="../../assets/nonView.svg"
												alt=""
											/>
										</div>
									</div>
									<div v-if="showTestCaseDataforclick" style="width: 75%">
										<div class="viewAnswer-left-card p-3 ml-2">
											<span class="candAnswer-tc-preview-head">Input</span>

											<div
												class="viewAnswer-tags-text ml-3 mt-2"
												v-html="showTestCaseData.inputValue"
											></div>
										</div>
										<div class="viewAnswer-left-card p-3 ml-2 mt-2">
											<span class="candAnswer-tc-preview-head">Output</span>
											<div
												class="viewAnswer-tags-text ml-3 mt-2"
												v-html="showTestCaseData.outputValue"
											></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div
				v-if="selectedAttempt.markingCheck"
				class="d-flex align-items-center justify-content-end"
			>
				<div class="d-flex align-items-center justify-content-center mr-3">
					<div class="topDiv d-flex mt-3">
						<label class="fieldsetStyle" style="z-index: 8"
							>Give Marks&nbsp;<span class="asterik">*</span></label
						>

						<b-form-input
							class="vcp-inputField"
							id="input-1"
							type="text"
							placeholder="Enter here"
							v-model="question.questionMarks"
							@input="updateCodeBetweenValue(parseInt(index))"
							:class="question.questionBody.betweenError ? 'error' : ''"
						></b-form-input>
						<div
							class="eval-validationicon"
							v-if="
								question.questionBody.betweenError &&
									!question.answerStatus.unattempted
							"
							v-b-popover.hover.top.v-danger="{
								content: `Entered valid marks Between -${selectedAttempt.negativeMark}  To  ${question.questionBody.marks}`,
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
						<div
							class="eval-validationicon"
							v-if="
								question.questionBody.betweenError &&
									question.answerStatus.unattempted
							"
							v-b-popover.hover.top.v-danger="{
								content: `Enter valid marks Between ${
									selectedAttempt.negativeMark > 0
										? selectedAttempt.negativeMark * -1
										: 0
								}  To  0`,
							}"
							variant="primary"
						>
							<img src="../../assets/deletepopupicon.svg" alt="" />
						</div>
					</div>
					<div class="progrm-totalmarktext mt-3 ml-2">
						/&nbsp;{{ question.questionBody.marks }}
					</div>
				</div>
				<div class="mt-3 mr-1">
					<b-button
						:disabled="question.questionBody.betweenError"
						@click="$bvModal.hide('ViewAnswerDatabank')"
						class="candAnswer-save-btn"
						>Give Marks</b-button
					>
				</div>
				<!-- <div class="d-flex justify-content-between">
          <div class="marks-input">
            <b-form-input>Enter Marks: /100</b-form-input>
          </div>
          <div>
            <img src="../../assets/projects-icons/cancel.svg" /><img
              src="../../assets/projects-icons/submit.svg"
            />
          </div>
        </div> -->
			</div>
		</b-modal>
		<b-modal
			id="viewdetailsmodal"
			centered
			hide-footer
			hide-header
			size="md"
			class="viewdetailsmodal"
		>
			<div class="attempt-heading-modal">
				Attempt {{ particularCandidatestore.attemptNo }} Details
			</div>
			<hr />
			<div class="xMarkCancel" @click="$bvModal.hide('viewdetailsmodal')">
				<img src="../../assets/xmark.svg" alt="" />
			</div>
			<div class="vpt-namebox mt-3">
				<div class="d-flex justify-content-between">
					<div
						class="attempt-section"
						style="margin-top: 15px; margin-left: 15px; color: #696969"
					>
						Name
					</div>
					<div
						class="attempt-name"
						style="margin-top: 15px; margin-right: 15px"
					>
						{{ particularCandidatestore.name }}
						<!-- {{ singledata.name }} -->
					</div>
				</div>
			</div>
			<!-- div for address  -->
			<div class="view-details-sections">
				<div class="view-details-main mt-3">
					<div class="d-flex justify-content-between">
						<div class="attempt-section" style="color: #6d6d6d">Test name</div>
						<div
							v-if="particularCandidatestore.stats"
							class="attempt-section"
							style="color: #6d6d6d"
						>
							Date :
							{{
								formatDate(
									particularCandidatestore.stats.timing.startTime,
									"dd-MM-yyyy"
								)
							}}
						</div>
						<div v-else>Date : -</div>
					</div>
					<div class="d-flex justify-content-between">
						<div class="attempt-section">
							{{ particularCandidatestore.testName }}
						</div>
						<div v-if="particularCandidatestore.evaluation">
							<span class="attempt-section">Result: </span>
							<span
								:class="
									particularCandidatestore.statusCode == 0
										? 'pr-fail'
										: 'pr-pass'
								"
								>{{ particularCandidatestore.status }}</span
							>
						</div>
					</div>
					<div class="attempt-section d-flex justify-content-between mt-3">
						<div class="d-flex">
							<div>
								<img src="../../assets/icons/proctoring/result.svg" alt="" />
							</div>
							<div class="ml-1">Marks</div>
						</div>
						<div>
							Total Marks :
							<template v-if="selectedAttempt.totalTestMarks">
								{{ particularCandidatestore.marks }}/
								{{ selectedAttempt.totalTestMarks.toString().slice(0, 4) }}
							</template>
						</div>
					</div>

					<div
						class="section-detail-main p-3"
						v-for="(secdetail, index) in particularCandidatestore.testResponse"
						:key="index"
					>
						<div class="view-details-submain">
							<div class="d-flex justify-content-between">
								<div class="ml-2 attempt-section">
									{{ secdetail.sectionName }}
									<!-- {{ i.sectionName }} -->
								</div>
								<div
									class="mr-2 attempt-name-show mt-1"
									:style="cssForDynamicColor"
								>
									{{ secdetail.sectionMarks }}/{{
										secdetail.serctionTotalMarks
									}}
									<!-- {{ i.sectionMarks }} / {{ i.sectionTotalMarks }} -->
								</div>
							</div>
						</div>
					</div>
				</div>

				<div
					class="viewmark-open-atmpt-box d-flex align-items-center position-relative pointer p-2"
				>
					<div class="attempt-section ml-3">Address</div>
				</div>
				<div class="viewmark-attempt-open-box p-2 pl-2 align-items-center">
					<div class="d-flex align-items-center mt-2">
						<div>
							<img src="../../assets/icons/proctoring/Email.svg" alt="" />
						</div>
						<div
							class="address-text ml-4"
							v-if="
								particularCandidatestore['stats'] != undefined &&
									particularCandidatestore.stats.geolocation.address &&
									particularCandidatestore.stats.geolocation.address
										.formatted_address
							"
						>
							{{
								particularCandidatestore.stats.geolocation.address
									.formatted_address
							}}
						</div>
						<div v-else>-</div>
					</div>
				</div>
			</div>
		</b-modal>
		<b-modal
			v-if="selectedAttempt.sandboxResults"
			id="proctoringModal"
			centered
			hide-footer
			hide-header
		>
			<main>
				<div
					class="sb-modal-head d-flex justify-content-between align-items-center"
				>
					<div class="pm-headtxt-sb">SonarQube</div>
					<div>
						<img
							@click="$bvModal.hide('proctoringModal')"
							class="rotate-on-hover pointer"
							src="../../assets/projects-icons/x-close.svg"
							alt=""
						/>
					</div>
				</div>
				<section class="proc-modal-overflow">
					<div class="d-flex pm-gap-3 flex-wrap p-4 align-items-stretch">
						<article
							v-for="metric in selectedAttempt.sandboxResults.SONARQUBE"
							:key="metric.metric"
							class="pm-card"
						>
							<h4>{{ metric.label }}</h4>
							<h2 class="pm-grey">{{ metric.value }}</h2>
							<h6>
								{{ metric.description }}
							</h6>
						</article>
					</div>
				</section>
				<div class="sb-modal-foot">
					<div class="eval-btns pm-btn-wdth mr-2">
						<b-button @click="$bvModal.hide('proctoringModal')">
							Okay
						</b-button>
					</div>
				</div>
			</main>
		</b-modal>
	</div>
</template>

<script>
import {
	getproctoringCandidatesv3,
	evaluateAnswers,
	testCaseRunner,
	getcodesnippetcompiler,
	evaluateSandbox,
} from "../../utils/apiFunctions.js";
import Media from "@dongido/vue-viaudio";
import { required, helpers } from "vuelidate/lib/validators";
import errorToast from "../../views/mixin/toast";
import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { isImage, isVideo, isAudio } from "../../utils/checkFileType.js";
import { mapGetters } from "vuex";
export default {
	name: "ViewCandidateProctorScreen",

	mixins: [errorToast],
	components: {
		Spinner,
		Media,
	},

	data() {
		return {
			sandboxMarks: null,
			giveMarks: false,
			validationsTrigger: false,
			lastWindowSize: {
				width: window.innerWidth,
				height: window.innerHeight,
			},
			tabIndex: 0,
			selindex: 0,
			activeForTopic: {},
			invalidmark: false,
			editorInstance: null,
			sandboxEval: true,
			value: 100,
			index: -1,
			showResult: false,
			compileMessage: "",
			compiledTestCasesResult: {},
			codeData: [],
			isPlaying: false,
			audio: null,
			audioPosition: 0,
			timelineWidth: "0%",
			audioDuration: 0,
			allQuestions: [],
			topicCardselected: null,
			programnumber: 1,
			codingquestions: [],
			codingsection: false,
			selectedCodeSection: {},
			question: {
				questionBody: {
					difficultyLevel: "",
				},
			},
			visibletc: [],
			tc: {
				inputValue: "",
				outputValue: "",
			},
			activeTab: "sections",
			activesubtab: "",
			sample: 2,
			runCode: false,
			loopVar: 8,
			tabsVar: 5,
			showIcon: 0,
			dispIcon: null,
			showTestCaseDataforclick: false,
			showTestCaseLeftside: true,
			loopProgramming: 14,
			showtopiccard: false,
			keyWordRepeatingCount: {},
			pdcards: 25,
			LoaderStatus: false,
			cameraFeedUrl: "",
			ScreenShareFeedUrl: "",
			showmcqans: "",
			candidateActivityLog: [],
			candidateActivityLogCount: [],
			selectedAttempt: {
				testResponse: [],
				stats: {},
				remarks: [],
				video: {
					camera: "",
				},
			},
			selectedSection: {},
			overallResult: {},
			status: "video",
			mtfcrctans: false,
			particularCandidatestore: {},
			addressView: false,
		};
	},
	computed: {
		buildAndRunDetails() {
			if ("BUILD" in this.selectedAttempt.sandboxResults) {
				return {
					label: "Build",
					value: this.selectedAttempt.sandboxResults.BUILD,
				};
			} else if ("RUN" in this.selectedAttempt.sandboxResults) {
				return {
					label: "Run",
					value: this.selectedAttempt.sandboxResults.RUN,
				};
			} else return null;
		},
		isValid() {
			if (this.sandboxMarks == null) {
				return false;
			}
			return (
				Number(this.sandboxMarks) <= Number(this.selectedAttempt.totalTestMarks)
			);
		},
		...mapGetters(["roles"]),
		cssForDynamicColor() {
			return {
				"--dynamicBorderColor":
					"#" +
					Math.random()
						.toString(16)
						.slice(-6),
			};
		},
		tcaseInput() {
			return this.showTestCaseData.inputValue.replace(/\n/g, "<br>");
		},
		tcaseOutput() {
			return this.showTestCaseData.outputValue.replace(/\n/g, "<br>");
		},
		compilemsg() {
			return this.compileMessage.data.replace(/\n/g, "<br>");
		},
		percentage() {
			return (50 / 100) * 100;
		},
		circumference() {
			return Math.floor(2 * 3.14 * 16);
		},
		progressOffset() {
			return Math.floor(
				this.circumference - (this.percentage / 100) * this.circumference
			);
		},
	},
	validations() {
		return {
			selectedSection: {
				sectionResponse: {
					$each: {
						questionMarks: {
							required,
							alpha: helpers.regex("alpha", /^-?\d*\.?\d+$/),
						},
					},
				},
			},
			selectedCodeSection: {
				sectionResponse: {
					$each: {
						questionMarks: {
							required,
							alpha: helpers.regex("alpha", /^-?\d*\.?\d+$/),
						},
					},
				},
			},
		};
	},
	watch: {
		// activeTab() {
		//   this.scrollToTop();
		// },
		lastWindowSize() {
			this.initializeEditor();
		},
	},
	async created() {
		this.LoaderStatus = true;
		if (this.$route.query.attemptNo) {
			await this.getProctorDetails(this.$route.query.attemptNo);
			this.tabIndex = parseInt(this.$route.query.attemptNo - 1);
		} else {
			this.getProctorDetails(1);
		}
	},
	methods: {
		getFormattedTopicName(topicName) {
			if (topicName === "Sandbox-KSGPdd3q0S#jl@B") return "Sandbox";
			else return topicName;
		},
		async vewSandboxCode() {
			this.$router.push({
				name: "view-code-sandbox",
				params: {
					testID: this.$route.params.testID,
					attemptNo: this.$route.query.attemptNo,
					topicID: this.$route.params.topicID,
					groupID: this.$route.params.groupID,
					userID: this.selectedAttempt.candidateID,
					emailID: this.selectedAttempt.emailID,
				},
			});
		},
		async evaluateSandboxMethod() {
			this.validationsTrigger = true;
			if (!this.isValid) return;
			this.LoaderStatus = true;
			try {
				const payload = {
					topicID: this.$route.params.topicID,
					testID: this.$route.params.testID,
					candidateID: this.$route.params.candidateID,
					groupID: this.$route.params.groupID,
					attemptNo: this.$route.query.attemptNo,
					evaluation: {},
				};
				let keyObj = {};
				keyObj[
					this.selectedAttempt.testResponse[0].sectionResponse[0].questionKey
				] = Number(this.sandboxMarks);
				payload.evaluation[
					this.selectedAttempt.testResponse[0].sectionID
				] = keyObj;
				const res = await evaluateSandbox(payload);
				if (res.status == 200) {
					this.giveMarks = false;
					this.selectedAttempt.evaluation = true;
					this.selectedAttempt.marks = Number(this.sandboxMarks);
				} else {
					throw new Error();
				}
			} catch (error) {
				console.log(error);
				this.errorToast(
					"Unable to evaluate, Please tag evaluator and try again"
				);
			} finally {
				this.LoaderStatus = false;
			}
		},
		scrollToTop() {
			const targetElement = document.getElementById("top1");
			targetElement.scrollTo({
				top: 0,
				behavior: "smooth", // Smooth scrolling animation
			});
		},
		modalShown() {
			window.addEventListener("resize", this.handleZoomChange);
		},
		modalHidden() {
			window.removeEventListener("resize", this.handleZoomChange);
		},
		hideIcon(index, data) {
			setTimeout(() => {
				const scrollContainer = this.$refs.scrollContainer;
				scrollContainer.scrollIntoView({ behavior: "smooth", block: "end" });
			}, 200);
			this.showTestCaseDataforclick = true;
			this.showTestCaseData = data;
			console.log(this.showTestCaseData, "showTestCaseData");

			this.showIcon = index;
		},
		initializeEditor() {
			let snip = this.codeData.body;
			const editorContainer = document.querySelector(".editorContainer");
			window.require.config({
				paths: {
					vs: "https://cdn.jsdelivr.net/npm/monaco-editor@latest/min/vs",
				},
			});
			window.require(["vs/editor/editor.main"], () => {
				this.editorInstance = window.monaco.editor.create(editorContainer, {
					value: snip,
					language: this.topicCardselected,
					theme: "vs-dark",
				});
			});
		},
		removeEditor() {
			if (this.editorInstance != null) {
				this.editorInstance.dispose(); // Dispose the editor instance
				const editorContainer = document.getElementById("editorContainer");
				while (editorContainer.firstChild) {
					editorContainer.firstChild.remove(); // Remove all child nodes from the editor container
				}
			}
		},
		async runCodeForCompilation(key) {
			const extractedCode = this.editorInstance.getValue();

			let payload = {
				submissions: [
					{
						language_id: this.codeData.languageID,
						source_code: extractedCode,
						userid: "780f7e99-ec8a-4d51-8d4e-3c5d5d1dcf70",
					},
				],
			};
			let payloadtestCasesRes = {
				language_id: this.codeData.languageID,
				source_code: extractedCode,
				questionKey: key,
			};
			let testCasesRes = await testCaseRunner(payloadtestCasesRes);
			this.compiledTestCasesResult = testCasesRes.data.data;
			let res = await getcodesnippetcompiler(payload);
			this.compileMessage = res.data.data;
			setTimeout(() => {
				const scrollContainer = this.$refs.scrollContainer;
				scrollContainer.scrollIntoView({ behavior: "smooth", block: "end" });
			}, 200);
			this.showResult = true;
			this.hideIcon(0, this.compiledTestCasesResult.testCaseResult[0]);
		},
		getTopicValue(data) {
			this.activeForTopic = data;
			this.showtopiccard = false;
			if (window.monaco?.editor) {
				const editor = window.monaco.editor.getModels()[0];
				editor.setValue(data.body);
				window.monaco.editor.setModelLanguage(
					editor,
					data.languageName == "c++" ? "cpp" : data.languageName
				);
			}
		},
		showInFullScreen() {
			const element = document.getElementById("editorContainer");
			setTimeout(() => {
				element.style.width = "100vw";
				this.editorInstance.layout();
			}, 100);
			if (document.fullscreenElement) {
				if (document.exitFullscreen) {
					document.exitFullscreen();
				} else if (document.mozCancelFullScreen) {
					// Firefox
					document.mozCancelFullScreen();
				} else if (document.webkitExitFullscreen) {
					// Chrome, Safari, and Opera
					document.webkitExitFullscreen();
				} else if (document.msExitFullscreen) {
					// IE/Edge
					document.msExitFullscreen();
				}
			} else {
				this.requestfullscreen(element);
			}
		},
		requestfullscreen(element) {
			if (element.requestFullscreen) {
				element.requestFullscreen();
			} else if (element.mozRequestFullScreen) {
				// Firefox
				element.mozRequestFullScreen();
			} else if (element.webkitRequestFullscreen) {
				// Chrome, Safari, and Opera
				element.webkitRequestFullscreen();
			} else if (element.msRequestFullscreen) {
				// IE/Edge
				element.msRequestFullscreen();
			}
		},
		handleZoomChange() {
			this.lastWindowSize = {
				width: window.innerWidth,
				height: window.innerHeight,
			};
			this.removeEditor();
		},
		displayIcon(i) {
			this.showTestCaseLeftside = true;
			this.dispIcon = i;
			this.tc = this.visibletc[i];
		},

		isImage,
		isAudio,
		isVideo,
		goBackPointer(data, selected) {
			if (this.$route.query.fromRoute == "sandbox") {
				this.$router.push({
					path: "/adminconsole",
					query: {
						type: "individual",
					},
				});
			} else {
				this.$router.push({
					path: `/proctoring/proctortest/${selected.groupID}/${data.candidateType}`,
					query: {
						name: data.groupName,
						summary: this.$route.query.summary,
						evaluated: this.$route.query.evaluated,
						groups: this.$route.query.groups,
						status: this.$route.query.status,
					},
				});
			}
		},
		viewCandidateModal(data) {
			this.particularCandidatestore = data;
			this.$bvModal.show("viewdetailsmodal");
		},
		// FORMAT DATE
		formatDate(inputDate, format) {
			const date = new Date(inputDate);
			const day = date.getDate();
			const month = date.getMonth() + 1;
			const year = date.getFullYear();
			format = format.replace("MM", month.toString().padStart(2, "0"));
			if (format.indexOf("yyyy") > -1) {
				format = format.replace("yyyy", year.toString());
			} else if (format.indexOf("yy") > -1) {
				format = format.replace("yy", year.toString().slice(2, 2));
			}
			format = format.replace("dd", day.toString().padStart(2, "0"));
			return format;
		},
		updateBetweenValue(index) {
			let negative = this.selectedAttempt.negativeMark * -1;
			if (
				this.selectedSection.sectionResponse[index].answerStatus.unattempted
			) {
				if (this.selectedSection.sectionResponse[index].questionMarks == "-0") {
					this.selectedSection.sectionResponse[
						index
					].questionBody.betweenError = true;
					this.selectedSection.sectionResponse[
						index
					].questionBody.negativeZero = true;
				} else if (
					parseInt(this.selectedSection.sectionResponse[index].questionMarks) <=
						0 &&
					parseInt(this.selectedSection.sectionResponse[index].questionMarks) >=
						negative
				) {
					this.selectedSection.sectionResponse[
						index
					].questionBody.betweenError = false;
					this.selectedSection.sectionResponse[
						index
					].questionBody.negativeZero = false;
				} else {
					this.selectedSection.sectionResponse[
						index
					].questionBody.betweenError = true;
					this.selectedSection.sectionResponse[
						index
					].questionBody.negativeZero = false;
				}
			} else {
				this.updateBetweenValueAttempted(index);
			}
			this.$forceUpdate();
		},
		updateBetweenValueAttempted(index) {
			let negative = this.selectedAttempt.negativeMark * -1;
			if (this.selectedSection.sectionResponse[index].questionMarks == "-0") {
				this.selectedSection.sectionResponse[
					index
				].questionBody.betweenError = true;
				this.selectedSection.sectionResponse[
					index
				].questionBody.negativeZero = true;
			} else if (
				parseInt(this.selectedSection.sectionResponse[index].questionMarks) <=
					this.selectedSection.sectionResponse[index].questionBody.marks &&
				parseInt(this.selectedSection.sectionResponse[index].questionMarks) >=
					negative
			) {
				this.selectedSection.sectionResponse[
					index
				].questionBody.betweenError = false;
				this.selectedSection.sectionResponse[
					index
				].questionBody.negativeZero = false;
			} else {
				this.selectedSection.sectionResponse[
					index
				].questionBody.betweenError = true;
				this.selectedSection.sectionResponse[
					index
				].questionBody.negativeZero = false;
			}
		},

		updateCodeBetweenValue(index) {
			let negative = this.selectedAttempt.negativeMark * -1;
			if (
				this.selectedCodeSection.sectionResponse[index].answerStatus.unattempted
			) {
				if (
					this.selectedCodeSection.sectionResponse[index].questionMarks == "-0"
				) {
					this.selectedCodeSection.sectionResponse[
						index
					].questionBody.betweenError = true;
					this.selectedCodeSection.sectionResponse[
						index
					].questionBody.negativeZero = true;
				} else if (
					parseInt(
						this.selectedCodeSection.sectionResponse[index].questionMarks
					) <= 0 &&
					parseInt(
						this.selectedCodeSection.sectionResponse[index].questionMarks
					) >= negative
				) {
					this.selectedCodeSection.sectionResponse[
						index
					].questionBody.betweenError = false;
					this.selectedCodeSection.sectionResponse[
						index
					].questionBody.negativeZero = false;
				} else {
					this.selectedCodeSection.sectionResponse[
						index
					].questionBody.betweenError = true;
					this.selectedCodeSection.sectionResponse[
						index
					].questionBody.negativeZero = false;
				}
			} else {
				this.updateCodeBetweenValueAttempted(index);
			}
			this.$forceUpdate();
		},
		updateCodeBetweenValueAttempted(index) {
			let negative = this.selectedAttempt.negativeMark * -1;
			if (
				this.selectedCodeSection.sectionResponse[index].questionMarks == "-0"
			) {
				this.selectedCodeSection.sectionResponse[
					index
				].questionBody.betweenError = true;
				this.selectedCodeSection.sectionResponse[
					index
				].questionBody.negativeZero = true;
			} else if (
				parseInt(
					this.selectedCodeSection.sectionResponse[index].questionMarks
				) <=
					this.selectedCodeSection.sectionResponse[index].questionBody.marks &&
				parseInt(
					this.selectedCodeSection.sectionResponse[index].questionMarks
				) >= negative
			) {
				this.selectedCodeSection.sectionResponse[
					index
				].questionBody.betweenError = false;
				this.selectedCodeSection.sectionResponse[
					index
				].questionBody.negativeZero = false;
			} else {
				this.selectedCodeSection.sectionResponse[
					index
				].questionBody.betweenError = true;
				this.selectedCodeSection.sectionResponse[
					index
				].questionBody.negativeZero = false;
			}
		},
		initializeAudio(data) {
			let blob = data;
			this.audio = new Audio(blob);
			this.audioDuration = this.selectedAttempt.communicationTest.communicationTestResponse.durationInSeconds;
			this.audio.onended = () => {
				this.isPlaying = false;
				this.audioPosition = 0;
				this.timelineWidth = "0%";
			};
			this.audio.ontimeupdate = () => {
				this.audioPosition = this.audio.currentTime;
				this.updateTimelineWidth();
			};
		},
		toggleAudio() {
			if (!this.audio) {
				this.initializeAudio(
					this.selectedAttempt.communicationTest.communicationTestResponse
						.analysisResult.audio
				);
			}
			if (this.isPlaying) {
				this.audio.pause();
			} else {
				this.audio.play();
			}

			this.isPlaying = !this.isPlaying;
		},
		updateTimelineWidth() {
			if (this.audio) {
				const progressPercentage =
					(this.audioPosition / this.audioDuration) * 100;
				this.timelineWidth = `${progressPercentage}%`;
			}
		},
		seekTimeline(event) {
			if (this.audio) {
				const timelineWidth = event.currentTarget.offsetWidth;
				const offsetX = event.offsetX;
				if (timelineWidth === 0) {
					return; // Avoid division by zero
				}
				const seekTime = (offsetX / timelineWidth) * this.audioDuration;
				if (isNaN(seekTime) || !isFinite(seekTime)) {
					return; // Avoid non-finite seek time
				}
				this.audio.currentTime = seekTime;
				this.audioPosition = seekTime;
				this.updateTimelineWidth();
			}
		},
		async evaluate() {
			let flag = this.sectionError();
			this.$v.$touch();
			if (this.$v.$invalid || flag) {
				this.errorToast("Please fill all details correctly!");
			}
			if (!this.$v.$invalid && !flag) {
				try {
					let payload = {
						topicID: this.selectedAttempt.topicID,
						testID: this.$route.params.testID,
						candidateID: this.$route.params.candidateID,
						groupID: this.$route.params.groupID,
						attemptNo: this.selectedAttempt.attemptNo,
						evaluation: {},
					};

					for (let i in this.selectedAttempt.testResponse) {
						let data1 = {};
						for (let j in this.selectedAttempt.testResponse[i]
							.sectionResponse) {
							data1[
								this.selectedAttempt.testResponse[i].sectionResponse[
									j
								].questionKey
							] = parseInt(
								this.selectedAttempt.testResponse[i].sectionResponse[j]
									.questionMarks
							);

							// sectionid
							payload.evaluation[
								this.selectedAttempt.testResponse[i].sectionID
							] = data1;
						}
					}

					const res = await evaluateAnswers(payload);
					if (res.status == 200) {
						this.getProctorDetails(this.selectedAttempt.attemptNo);
						this.successToast(
							`Evaluated attempt ${this.selectedAttempt.attemptNo} successfully`
						);
					} else {
						this.errorToast(res.data.data.Details);
					}
				} catch (error) {
					throw new Error(`Failed! Status:${error.status}`);
				}
			}
		},

		sectionError() {
			for (const response of this.selectedAttempt.testResponse) {
				let sectionError = false;

				for (const sectionResp of response.sectionResponse) {
					if (
						sectionResp.questionMarks === "" ||
						sectionResp.questionMarks === undefined ||
						sectionResp.questionBody.betweenError
					) {
						sectionError = true;
						break;
					}
				}

				response.sectionError = sectionError;
			}

			this.$forceUpdate();
			let item = this.selectedAttempt.testResponse.find(
				(object) => object.sectionError
			);
			return Boolean(item);
		},
		async getProctorDetails(attempt) {
			this.LoaderStatus = true;
			let payload = {
				topicID: this.$route.params.topicID,
				testID: this.$route.params.testID,
				groupID: this.$route.params.groupID,
				candidateID: this.$route.params.candidateID,
				attemptNo: attempt,
			};
			const res = await getproctoringCandidatesv3(payload);
			if (res.status == 200) {
				this.overallResult = res.data.data;
				if (res.data.data.data.communicationTest) {
					this.keyWordRepeatingCount =
						res.data.data.data.communicationTest.communicationTestResponse.keyWordRepeatingCount;
				}
				this.selectAttempt(res.data.data.data);
				this.LoaderStatus = false;
				this.$router.push({
					path: `/proctoring/evaluatetest/${this.$route.params.testID}/${this.$route.params.topicID}/${this.$route.params.groupID}/${this.$route.params.candidateID}/${this.$route.params.candidateType}`,
					query: {
						attemptNo: attempt,
					},
				});
			}
		},

		selectSection(section) {
			this.selectedSection = section;
		},
		selectCodeSection(index) {
			this.programnumber = index + 1;
			this.selectedCodeSection = this.codingquestions[index];
		},
		viewanswer(question, index) {
			this.showResult = false;
			this.showTestCaseDataforclick = false;
			this.compiledTestCasesResult = {};
			this.showTestCaseData = {};
			this.question = question;
			this.visibletc = this.question.questionBody.testCases.filter(
				(obj) => obj.visible
			);
			this.dispIcon = 0;
			this.tc = this.visibletc[0];
			this.codeData = this.question.answer;
			this.activeForTopic = this.codeData.languagename;
			this.topicCardselected = this.codeData.languagename;
			this.index = index;
			setTimeout(() => {
				this.initializeEditor();
				this.LoaderStatus = false;
			}, 800);
		},
		selectAttempt(attempt) {
			this.status = "video";
			this.selectedAttempt = attempt;
			if (this.selectedAttempt.testResponse.length != 0) {
				this.selectedSection = this.selectedAttempt.testResponse[0];
				this.activesubtab = this.selectedSection.sectionName;
				this.resetErrors();
				this.updateCorrectAnswers();

				this.allQuestions = this.selectedAttempt.testResponse.filter(
					(obj) => !obj.codingSection
				);
				this.codingquestions = this.selectedAttempt.testResponse.filter(
					(obj) => obj.codingSection
				);
				if (this.codingquestions.length > 0) {
					this.selectedCodeSection = this.codingquestions[0];
				}
				this.handleunattemptd();
			}
		},
		handleunattemptd() {
			this.selectedSection.sectionResponse.forEach((question) => {
				if (
					question.answerStatus.unattempted &&
					question.questionBody.config.config.autoCorrection
				) {
					question["questionMarks"] = 0;
				}
			});
			if (this.codingquestions.length > 0) {
				this.selectedCodeSection.sectionResponse.forEach((question) => {
					if (
						question.answerStatus.unattempted &&
						question.questionBody.config.config.autoCorrection
					) {
						question["questionMarks"] = 0;
					}
				});
			}
		},
		updateCorrectAnswers() {
			for (const response of this.selectedAttempt.testResponse) {
				for (const sectionResp of response.sectionResponse) {
					const queskey = sectionResp.questionKey.slice(0, 3);

					if (queskey === "MCQ") {
						this.updateMCQCorrectAnswer(sectionResp);
					} else if (queskey === "MAF" && sectionResp.answer !== null) {
						this.updateMAFCorrectAnswer(sectionResp);
					}
				}
			}
		},
		updateMCQCorrectAnswer(sectionResp) {
			for (const option of sectionResp.questionBody.options) {
				if (option.check) {
					sectionResp.questionBody.correctanswer = option.value;
				}
			}
		},

		updateMAFCorrectAnswer(sectionResp) {
			for (const mtfAns of sectionResp.answer) {
				for (const ansKey of sectionResp.questionBody.answerKey) {
					const mtfSideBAnswer = ansKey.sideB;
					if (mtfAns === mtfSideBAnswer) {
						this.mtfcrctans = true;
					}
				}
			}
		},

		resetErrors() {
			for (const response of this.selectedAttempt.testResponse) {
				response.sectionError = false;
				response.sectionError = false;

				for (const sectionResp of response.sectionResponse) {
					sectionResp.questionBody.betweenError = false;

					const queskey = sectionResp.questionKey.slice(0, 3);
					if (queskey === "MCQ") {
						for (const option of sectionResp.questionBody.options) {
							if (option.check) {
								sectionResp.questionBody.correctanswer = option.value;
							}
						}
					} else if (queskey === "MAF" && sectionResp.answer !== null) {
						for (const mtfAns of sectionResp.answer) {
							for (const ansKey of sectionResp.questionBody.answerKey) {
								const mtfSideBAnswer = ansKey.sideB;
								if (mtfAns === mtfSideBAnswer) {
									this.mtfcrctans = true;
								}
							}
						}
					}
				}
			}

			this.allQuestions = this.selectedAttempt.testResponse.filter(
				(obj) => !obj.codingSection
			);
			this.codingquestions = this.selectedAttempt.testResponse.filter(
				(obj) => obj.codingSection
			);
			if (this.codingquestions) {
				this.selectedCodeSection = this.codingquestions[0];
			}
		},

		getProctorDetailsData(data) {
			if (this.overallResult.attempts.length > 1) {
				this.getProctorDetails(data);
			}
		},
		showmcqanswer(data) {
			this.showmcqans = data;
		},
		playStream(source) {
			setTimeout(() => {
				let vendor = document.getElementById("screenshare");
				vendor.src = source;
				vendor.play();
			}, 500);
		},
		vidplay(value) {
			let test = document.querySelectorAll("video");
			let data = value;

			let array = data.split(":");
			let seconds =
				parseInt(array[0], 10) * 60 * 60 +
				parseInt(array[1], 10) * 60 +
				parseInt(array[2], 10);
			for (const item of test) {
				item.currentTime = seconds;
			}
		},
	},
};
</script>

<style>
.bct-code-body {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow: auto;
	height: calc(100vh - 365px);
	color: #ffffff;
	font-size: 14px;
}

.bct-code-body-preview {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow: auto;
	/* height: calc(100vh - 246px); */
	color: #ffffff;
	font-size: 14px;
}
.tc-test-result {
	font-weight: 500;
	font-size: 16px;
	color: #333333;
}
.tc-bottom-button {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 15px;
}
.tc-redTop {
	background: #f15c6a;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}
.tc-greenText {
	font-weight: 500;
	font-size: 12px;
	color: #1cb803;
}
.tc-TC-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	position: relative;
}
.tc-code-body-preview {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow: auto;
	height: calc(100vh - 335px);
	color: #ffffff;
	font-size: 14px;
}
.tc-many-testCase-text {
	font-size: 12px;
	font-weight: 500;
	color: #696969;
}
.tc-many-testCase-right {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
}
.cq-lang-container {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	padding: 5px 15px;
}
.cq-selectLang-cont {
	position: absolute;
	border-radius: 5px;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	background: #fff;
	box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.12);
	z-index: 1000;
	width: 100%;
	height: fit-content;
	max-height: 163px;
	overflow: auto;
}

.cq-langline {
	border: 1px solid #c4c4c4;
	width: 0px;
	height: 12px;
}

.cq-accept-lang {
	font-weight: 400;
	font-size: 12px;
	color: #464667;
}

.cq-lang-text {
	font-weight: 500;
	font-size: 12px;
	color: #464667;
}
.cq-lang-text {
	font-weight: 500;
	font-size: 12px;
	color: #464667;
}
.cq-selectLang-cont {
	position: absolute;
	border-radius: 5px;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	background: #fff;
	box-shadow: 0px 4px 14px 0px rgba(0, 0, 0, 0.12);
	z-index: 1;
	width: 100%;
	height: fit-content;
	max-height: 163px;
	overflow: auto;
}
.cq-typeradio:nth-child(odd) {
	background: #f4f4f4;
}

.cq-typeradio:nth-child(even) {
	background: #fdfdfd;
}

.cq-selectLang-cont .form-group {
	margin-bottom: 0px;
}
.tc-many-trialCase-left {
	min-height: auto;
	max-height: calc(100vh - 635px);
	overflow: auto;
	background: #ffffff;
	border: 1px solid rgba(196, 196, 196, 0.25);
	border-radius: 3px;
}
.tc-card-subtext {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.tc-cancel-btn {
	background: #fcfcfc;
	border: 1px solid #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #72738e;
	padding: 5px 15px;
}
.vpt-priorityicon {
	position: absolute;
	top: 0;
	right: 0;
}
.section-validation-icon {
	position: absolute;
	top: 10px;
	right: -4px;
}
.activity-status {
	font-family: "Poppins";
	font-style: normal;
	font-weight: 400;
	font-size: 13px;
	line-height: 20px;
	color: #72738e;
}
.eval-negativemark-heading {
	background: #ffffff;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 3px;

	height: calc(100vh - 100);
	padding: 5px;

	background: #f4f4f4;
}
.eval-status-button-heading {
	font-family: "Poppins";
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	line-height: 28px;
	color: #72738e;
}
.eval-button-head {
	font-family: "Poppins";
	font-style: normal;
	font-weight: 400;
	font-size: 14px;
	line-height: 21px;
	color: #6d6d6d;
}
.eval-button-box {
	background: #ffffff;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	height: calc(100vh - 100);
	padding: 10px;
	margin: 20px 0 0 0;
}
.eval-status {
	background: #ffffff;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	height: calc(100vh - 100);
	padding: 5px;
}
.evaluated-status-evaluated {
	font-family: "Poppins";
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	line-height: 28px;
	color: #038e00;
	margin-right: 4rem;
}
.evaluated-status {
	font-family: "Poppins";
	font-style: normal;
	font-weight: 500;
	font-size: 13px;
	line-height: 28px;
	color: #ad1927;
}
.img-height-width {
	width: 100% !important;
	height: 100%;
}
.eval-validationicon {
	position: absolute;
	top: 4px;
	z-index: 45;
	/* left: 85px; */
	right: 5px;
	background: var(--bg-white);
}
.eval-validationicon-top {
	/* top: 4px; */
	background: var(--bg-white);
}
.vcp-email {
	font-weight: 400;
	font-size: 13px;
	color: #696969;
}
.pr-tabcontent-evaltest {
	height: calc(100vh - 336px);
	overflow-x: hidden;
	overflow-y: auto;
}

.pr-tabcontent-evaltest-programming-table {
	height: calc(100vh - 405px);
	overflow-x: hidden;
	overflow-y: auto;
}

.nav-tabs {
	border-bottom: 1px solid #dee2e6;
	/* overflow: auto; */
	overflow-x: auto;
	overflow-y: hidden;
}
.nav {
	flex-wrap: nowrap !important;
}
.pr-viewmark {
	background: #ffffff;
	height: 50px;
	border: 1px solid #e8e8e8;
	box-shadow: 0px 2px 4px rgba(209, 209, 209, 0.25);
	border-radius: 3px;
}
.pvc-parentdiv {
	position: relative;
	top: 70px;
	height: calc(100vh - 70px);
	width: calc(100vw - 60px);
	left: 60px;
	padding: 20px 10px 20px 25px;
}
.vcp-top-left-container {
	background: #fbfbfb;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	width: 30%;
	min-height: 275px;
	max-height: auto;
}
.vcp-bottom-left-container {
	background: #fbfbfb;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	width: 30%;
	/* height: calc(100vh - 445px); */
	height: calc(100vh - 180px);
}
.vcp-bottom-right-container-div {
	width: 70%;
	height: calc(100vh - 188px);
}
.vcp-bottom-right-container {
	background: #fbfbfb;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	/* width: 70%; */
	/* height: calc(100vh - 445px); */
	/* height: 70%; */
}
.vcp-top-id-container {
	background: #fbfbfb;
	border: 0.7px solid #e5e5e5;
	box-shadow: 0px 0px 20px rgba(86, 86, 86, 0.13);
	border-radius: 5px;
	width: 35%;
	min-height: 275px;
	max-height: auto;
	overflow-y: hidden;
	overflow-x: auto;
}
.gridgreencolorDynamic {
	width: 4px;
	height: 56px;
	border-radius: 2px;
	position: absolute;
	left: -5px;
	top: -6px;
}
.gridbluecolor {
	width: 4px;
	height: 98%;
	border-radius: 2px;
	position: absolute;
	left: 1px;
	top: 2px;
	background: #84a3fe;
}
.gridgreencolor {
	width: 4px;
	height: 98%;
	border-radius: 2px;
	position: absolute;
	left: 1px;
	top: 2px;
	background: #4ef085;
}
/* class for non evaluated */
.gridyellowcolor {
	width: 4px;
	height: 98%;
	border-radius: 2px;
	position: absolute;
	left: 1px;
	top: 2px;
	background: #ffc145;
}
.orangecolor {
	width: 4px;
	height: 98%;
	border-radius: 2px;
	position: absolute;
	left: 1px;
	top: 2px;
	background: #ffc145;
}
.gridredcolor {
	width: 4px;
	height: 98%;
	border-radius: 2px;
	position: absolute;
	left: 1px;
	top: 2px;
	background: #e04a58;
}
.pr-fourthscreen-logtable tbody {
	display: block;
	border-radius: 5px;
	overflow: auto;
	height: calc(100vh - 522px);
	margin-top: 5px;
	width: calc(100% - 5px);
}
.pr-fourthscreen-logtable tbody tr:nth-child(odd) {
	background: #f4f4f4;
}

.pr-fourthscreen-logtable tbody tr:nth-child(even) {
	background: #fdfdfd;
}
.proctoringTabSelected {
	font-weight: 600;
	font-size: 14px;
	color: #72738e;
	border-bottom: 5px solid #72738e;
	border-radius: 5px;
}
.proctoringTabUnSelected {
	font-weight: 500;
	font-size: 14px;
	color: #72738e;
	border-bottom: 1px solid #72738e;
}
.proctoring-sub-heading {
	font-weight: 500;
	font-size: 14px;
	color: #72738e;
}
.overall-smmary {
	font-weight: 500;
	font-size: 14px;
	color: #1a4164;
}
.ans-sheet-txt {
	font-weight: 600;
	font-size: 16px;
	color: #464667;
}
.proct-overall-summery {
	height: 37%;
	overflow: auto;
}
.pr-left-column-container {
	/* width: 660px; */
	height: 387px;
	background: #fbfbfb;
	box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.25);
	border-radius: 8px;
}

.pr-right-column-container {
	/* width: 655px; */
	height: 387px;
	background: #fbfbfb;
	box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.25);
	border-radius: 8px;
}

.pr-left-column-left-div {
	width: 346px;
	height: 157px;
	background: #ffffff;
	border-radius: 4px;
	/* overflow: auto; */
}
.pr-left-column-left-div-inner {
	width: 333px;
	height: 125px;
	background: #ffffff;
	border-radius: 4px;
	overflow: auto;
}

.pr-left-column-right-div {
	border: 2px solid red;
	height: 157px;
	width: 270px;
}

.pr-keywords-used-cards {
	width: 320px;
	height: 30px;
	background: #f6f6fc;
	border-radius: 3px;
}

.pr-keywords-used-cards-txt {
	font-weight: 400;
	font-size: 12px;
	text-align: justify;

	color: #6d6d6d;
}

.pr-candidate-answer {
	/* width: 628px; */
	height: 78px;
	background: #fafafa;
	border: 1px solid #c8c8c8;
	border-radius: 3px;
	overflow: auto;
}

.pr-communication-test-result-bottom-div {
	/* width: 628px; */
	height: 45px;
	background: #ffffff;
	box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.06);
	border-radius: 5px;
}

.pr-keyword-use {
	font-weight: 400;
	font-size: 12px;
	color: #464667;
}

.pr-options {
	font-weight: 400;
	font-size: 11px;
	color: #72738e;
}

.pr-typing-test-cards {
	background: #ffffff;
	box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.06);
	border-radius: 6px;
	width: 200px;
	height: 60px;
}

.pr-typing-test-cards-blue-text {
	font-weight: 500;
	font-size: 11px;
	color: #84a3fe;
}
.typing-test-subheading {
	font-weight: 600;
	font-size: 13px;
	line-height: 20px;
	color: #72738e;
}
.pr-question {
	/* width: 623px; */
	height: 103px;
	background: #f6f6fc;
	border-radius: 3px;
	overflow: auto;
}

.pr-answer {
	/* width: 623px; */
	height: 78px;
	overflow: auto;
	background: #fafafa;
	border: 1px solid #c8c8c8;
	border-radius: 3px;
}

/* .pr-main-card-container {
  overflow-x: hidden;
} */
/* .vcps .form-control {
  width: 70%;
} */
.pr-candidate-header-div {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
}
.priority-div {
	background: #fff1c3;
	box-shadow: 0px 0px 0px rgba(86, 86, 86, 0.13);
	font-weight: 400;
	font-size: 12px;
	color: #ababab;
}
.pr-feedback-container {
	background: #fbfbfb;
	box-shadow: 0px 0px 9px rgba(0, 0, 0, 0.25);
	border-radius: 8px;
	height: 229px;
	color: #6d6d6d;
}
.pr-feedback-remarks {
	background: #f6f6fc;
	border-radius: 3px;
	height: 100px;
	overflow: auto;
}
.rating-input {
	color: #ffc145 !important;
	background: unset;
	border: none;
	background-color: unset !important;
}
.pr-overall-log {
	height: calc(100vh - 500px);
	overflow: auto;
}
.pr-image-div {
	width: 30%;
}

.topDiv > .vcp-inputField {
	border: 1px solid var(--input-border);
	/* padding: 5px; */
	border-radius: 3px !important;
	font-size: var(--size-12);
	font-weight: var(--weight-LM);
	line-height: 18px;
	z-index: 5;
	width: 101px;
	/* padding-left: 6px; */
	background: var(--bg-inputfield);
}
.viewmark-attempt-open-box {
	background: #f8f8f8;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	margin-bottom: 15px;
}
.viewmark-open-atmpt-box {
	background: #f5f5f5;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 6px 6px 0px 0px;
	padding: 15px !important;
	margin-top: 15px;
}

/* nav-tabs design starts from here */
.main-tabs .nav-tabs {
	width: 400px;
}

.main-tabs .nav-tabs .nav-link:not(.active) {
	color: #3379b3;
	font-size: 14px;
	font-weight: 600;
	border: 1px solid #f0f0f0;
	background: #fff;
	width: 200px;
	text-align: center;
}

.main-tabs .nav-tabs .nav-link.active {
	background: #3379b3;
	color: #fff;
	box-shadow: 0px 4px 6px 0px rgba(196, 196, 196, 0.13);
	font-size: 14px;
	font-weight: 600;
	width: 200px;
	text-align: center;
}

.sub-tabs .nav-tabs {
	background: #fff;
	box-shadow: 0px 0px 14px 0px rgba(196, 196, 196, 0.5);
	border: unset !important;
	min-width: auto;
	width: 100%;
	overflow-x: auto;
	overflow-y: hidden;
	transition: border 250ms ease;
}

.sub-tabs .nav-tabs .nav-link {
	border: unset !important;
	border-bottom: unset !important;
	width: 250px;
	color: #72738e !important;
	font-size: 14px;
	font-weight: 600;
	text-align: center;
}

.sub-tabs .nav-tabs .nav-link.active {
	border: unset;
	border-bottom: 5px solid #3379b3 !important;
	background: #ffffff;
	color: #3379b3;
	font-size: 14px;
	font-weight: 600;
	text-align: center;
}

/* coding test programming design starts from here */
.codingTestprgrm {
	border-radius: 5px;
	background: #f9f9f9;
	padding: 15px;
}

.codingTestprgrm-text-1 {
	color: #363636;
	font-size: 16px;
	font-weight: 500;
}

.codingTestprgrm-text-2 {
	color: #363636;
	font-size: 16px;
	font-weight: 600;
}

.codingTestprgrm-container-text-head {
	color: #72738e;
	font-size: 12px;
	font-weight: 600;
}

.codingTestprgrm-container-body {
	color: #72738e;
	font-size: 13px;
	font-weight: 400;
}

.progrm-totalmarktext {
	color: #6d6d6d;
	font-size: 14px;
	font-weight: 400;
}

.viewAnswer-class {
	color: #0a56c8;
	font-size: 14px;
	font-family: Poppins;
	font-style: normal;
	font-weight: 500;
	line-height: normal;
	text-decoration-line: underline;
}

/* view answer modal design */
#ViewAnswerDatabank .modal-xl {
	max-width: 90%;
	width: 100%;
}
/* @media (min-width: 1200px) {
  #ViewAnswerDatabank .modal-xl {
    max-width: 1700px;
  }
} */

.viewAnswerMaincontent {
	height: calc(100vh - 192px);
	overflow-x: hidden;
	overflow-y: auto;
}

.viewAnswerLeftSideContent {
	width: 40%;
	padding: 10px;
	border-radius: 10px;
	background: #fff;
	box-shadow: 2px 4px 12px 0px rgba(0, 0, 0, 0.08);
	min-height: auto;
	max-height: calc(100vh - 225px);
	overflow: auto;
}

.viewAnswerRightSideContent {
	width: 60%;
	height: calc(100vh - 210px);
	overflow-x: hidden;
	overflow-y: auto;
}

.ViewAnswer-head-text {
	color: #545454;
	font-size: 13px;
	font-weight: 500;
}

.viewAnswer-small-box {
	background: #ffffff;
	box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
	border-radius: 3px;
	font-weight: 500;
	color: #3f698e;
	font-size: 11px;
	padding: 5px 10px;
	margin-right: 15px;
}

.viewAnswer-tags-text {
	color: #696969;
	font-size: 13px;
	font-weight: 400;
}

.viewAnswer-totalQuesnum {
	color: #1a4164;
	font-size: 14px;
	font-weight: 600;
}

.viewAnswer-left-card {
	padding: 5px;
	border-radius: 5px;
	background: #fff;
	box-shadow: 0px 1px 8px 0px rgba(196, 196, 196, 0.25);
}

.viewAnswer-left-card ul li {
	color: #696969;
	font-size: 13px;
	font-weight: 400;
}

.list-style-class ul li {
	color: #696969;
	font-size: 13px;
	font-weight: 400;
	list-style: none;
}

.viewAnswer-left-card span {
	color: #333;
	font-size: 13px;
	font-weight: 600;
}

.candAnswer-bottom-button span {
	color: #333;
	font-size: 13px;
	font-weight: 600;
}

.candAnswer-code-body {
	background: #3c3c3c;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	overflow-x: hidden;
	overflow-y: auto;
	height: 400px;
	color: #ffffff;
	font-size: 14px;
}

.candAnswer-save-btn {
	background: #72738e;
	border-radius: 3px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 5px 15px;
}

.candAnswer-test-result {
	color: #333;
	font-size: 16px;
	font-weight: 500;
}

.candAnswer-bottom-button {
	background: #ffffff;
	box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
	border-radius: 8px;
	padding: 8px;
	min-height: auto;
	overflow: auto;
	max-height: 380px;
}

.candAnswer-redTop {
	background: #f15c6a;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 10px 10px;
}

.candAnswer-greenTop {
	background: #1cb803;
	box-shadow: 0px 1px 8px rgba(196, 196, 196, 0.25);
	border-radius: 5px 5px 0px 0px;
	font-weight: 500;
	font-size: 13px;
	color: #ffffff;
	padding: 10px 10px;
}

.candAnswer-tc-card {
	background: #ffffff;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	position: relative;
}

.candAnswer-tc-many-trialCase-left {
	min-height: auto;
	max-height: 185px;
	overflow: auto;
	background: #ffffff;
	border: 1px solid rgba(196, 196, 196, 0.25);
	border-radius: 3px;
}

.candAnswer-tc-greenText {
	font-weight: 500;
	font-size: 12px;
	color: #1cb803;
}

.candAnswer-showClickedTestCase {
	font-weight: 700 !important;
	font-size: 12px !important;
}

.candAnswer-tc-preview-head {
	font-size: 12px;
	font-weight: 600;
	color: #333333;
}

.proctoring-tc {
	height: 163px;
	overflow: auto;
	background: #fbfafa;
	border-radius: 5px;
	cursor: pointer;
}

.proctoring-tc-text {
	font-size: 12px;
	font-weight: 500;
	color: #696969;
}

.proctoring-tc-sel-text {
	font-weight: 700;
	font-size: 12px;
	color: #3379b3;
	background: #eef2f5;
	border-radius: 5px 5px 0px 0px;
}

.candAnswer-tc-many-trialCase-sel-text {
	background: #eef2f5;
}

.candAnswer-tc-greenText {
	font-weight: 500;
	font-size: 12px;
	color: #1cb803;
}
/* fixed size for modal */
.view-details-main {
	overflow-y: auto;
}
.view-details-sections {
	overflow-y: auto;
	min-height: auto;
	max-height: 414px;
}
.timeline {
	width: 100%;
	height: 4px;
	background-color: #ccc;
	position: relative;
	margin-top: 8px;
}

.timeline-progress {
	height: 100%;
	background-color: #007bff;
	position: absolute;
	top: 0;
	left: 0;
}
.cj-filter-modal {
	padding: 10px;
	background: #ffffff;
	border: 0.7px solid rgba(114, 115, 142, 0.5);
	box-sizing: border-box;
	box-shadow: 0px 4px 14px rgb(0 0 0 / 12%);
	border-radius: 5px;
	z-index: 6;
	position: absolute;
	width: 355px;
	height: 320px;
	right: 0px;
	top: 40px;
}
.eval-btns .btn-secondary {
	background-color: #72738e;
	border-radius: 40px;
	border: 1px solid #72738e;
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 6px 22px;
	font-family: "Montserrat";
	font-weight: 600;
	font-size: 13px;
	color: #ffffff;
}
.eval-btns .btn-secondary:focus {
	/* border: 2px solid #ffffff !important; */
	box-shadow: 0px 4px 4px 0px #00000040;
}
.performance-cont {
	background: #ffffff;
	box-shadow: 0px 0px 14px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
}
.flex-1 {
	flex: 1;
}
.headtxt-sb {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #000000;
}
.pm-headtxt-sb {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 18px;
	color: #000000;
}
.headtxt-blue {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-size: 16px;
	text-decoration-line: underline;
	color: #20639b;
}
.parameter-txt-hd {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #72738e;
}
.param-txt-hdbold {
	font-family: "Lato", sans-serif;
	font-weight: 700;
	font-size: 18px;
	color: #72738e;
}
.parameter-box {
	background: #fcfcfc;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	margin-bottom: 10px;
}
.score-circle {
	width: 40px;
	height: 40px;
	background: rgba(114, 115, 142, 0.1);
	border-radius: 50%;
	padding: 6px 9px;
}
.score-txt {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 12px;
	color: #72738e;
}
.evaluate-sb .progress .bg-success {
	background: #038e00 !important;
	border-radius: 15px;
}
.evaluate-sb .progress .bg-danger {
	background: #eb0002 !important;
	border-radius: 15px;
}
.evaluate-sb .progress .bg-warning {
	background: #f28b2b !important;
	border-radius: 15px;
}
.evaluate-sb .progress {
	width: 100%;
	background-color: transparent;
	height: 7px;
	color: transparent;
}
.evaluate-sb .progress-bar {
	color: transparent;
}
circle {
	transition: stroke-dashoffset 0.3s ease;
}
.donutPos {
	transform: rotate(-90deg);
}
.dash-prog {
	position: absolute;
	top: 3px;
	left: 26px;
}
.prog-width {
	width: 160px;
}
.donut-prog-txt {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 20px;
	color: #72738e;
	position: absolute;
	bottom: 70px;
}
.performance-line {
	height: 55px;
	width: 1px;
	opacity: 0.9;
	border: 1px solid rgba(114, 115, 142, 0.2);
}
.sb-modal-head {
	padding: 20px;
	border-bottom: 1px solid #e4e7ec;
}
.sb-modal-body {
	padding: 15px;
}
#performance-modal .modal-body,
#proctoringModal .modal-body {
	padding: 0rem;
}
.head-row {
	background: rgba(114, 115, 142, 0.08);
	padding: 10px;
}
.head-row-txt {
	font-family: "Lato", sans-serif;
	font-weight: 400;
	font-size: 15px;
	color: #72738e;
}
.indicator-bar {
	width: 3px;
	height: 50px;
	position: absolute;
	bottom: -13px;
	left: 0px;
	background: #72738e;
	border-radius: 1px;
}
.body-row {
	background: #fcfcfc;
	box-shadow: 0px 4px 15px rgba(196, 196, 196, 0.5);
	border-radius: 5px;
	padding: 5px;
	display: flex;
	align-items: center;
}
.table-overflow {
	height: calc(100vh - 470px);
	overflow-y: auto;
}
.features-txt {
	font-family: "Lato", sans-serif;
	font-weight: 600;
	font-size: 16px;
	color: #333333;
}
.features-pts {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 15px;
	color: #3a3c40;
}
.sb-modal-foot {
	padding: 20px;
	display: flex;
	justify-content: end;
	align-items: center;
	border-top: 1px solid #d7d7d7;
}
.marks-input {
	padding: 10px 14px;
	position: absolute;
	width: 175px;
	height: 32px;
	background: #ffffff;
	border: 1px solid #d0d5dd;
	box-shadow: 0px 1px 2px rgba(16, 24, 40, 0.05);
	border-radius: 8px;
}

.evaluate-sandbox-input {
	height: 32px;
	width: 175px;
	padding-right: 45px;
	border-radius: 8px;
}

.width-80px {
	width: 80px !important;
}

.out-off-marks {
	position: relative;
	width: max-content;
	left: -43px;
}

.out-off-marks-eval {
	position: relative;
	width: max-content;
	left: -43px;
	top: 5px;
}

.red-border {
	border: 1px solid red !important;
}

.proc-modal-overflow {
	height: calc(100vh - 365px);
	max-height: 580px;
	overflow-x: hidden;
	overflow-y: auto;
}
.pm-card {
	box-shadow: 0px 4px 15px 0px #c4c4c480;
	background-color: #fcfcfc;
	display: flex;
	flex-direction: column;
	align-items: center;
	width: 215px;
	gap: 20px;
	border-radius: 5px;
	padding: 8px 14px;
}
.pm-card h4 {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 16px;
	color: #333333;
}
.pm-card h2 {
	font-family: "Montserrat", sans-serif;
	font-weight: 600;
	font-size: 22px;
	color: #eb0002;
}
.pm-card h6 {
	font-family: "Montserrat", sans-serif;
	font-weight: 500;
	font-size: 13px;
	text-align: center;
	color: #72738e;
}
#proctoringModal .modal-dialog {
	max-width: 1208px;
}
.pm-gap-3 {
	gap: 20px;
}
.pm-grey {
	color: #72738e !important;
}
.pm-btn-wdth .btn-secondary {
	width: 100px;
}
.pm-width-unset {
	flex: 1;
}
.pm-no-data-txt {
	font-family: "Lato", sans-serif;
	font-weight: 500;
	font-style: italic;
	font-size: 16px;
	color: #344054;
}
.pm-w-35 {
	flex-basis: 35%;
	flex-grow: 1;
}
.pm-w-65 {
	flex-basis: 65%;
	flex-grow: 1;
}
</style>
